export default {
  "account.disabled.contactUs": "Se pensi si tratti di un errore, contattaci",
  "account.disabled.contactUsVetting":
    "Per rendere operativa la tua utenza abbiamo bisogno di maggiori informazioni sulla tua identità: ti invitiamo a contattarci attraverso il nostro sito web indicando nel messaggio il tuo indirizzo email aziendale e il seguente codice: <b>{code}</b><br/><br/>Valuteremo la tua richiesta e, se conforme, provvederemo ad abilitare il tuo account nel più breve tempo possibile.",
  "account.disabled.desc.customer":
    "Il  tuo account è stato bloccato per problemi amministrativi o per mancato pagamento. <br/>Ti invitiamo a verificare nella tua <a href='https://www.qboxmail.it/manager/clientarea.php' target='_blank'>area clienti</a> se sono presenti delle fatture non pagate.<br/>In caso di problemi ti invitiamo a contattarci tramite <a href='https://www.qboxmail.it/manager/clientarea.php' target='_blank'>ticket</a>.",
  "account.disabled.desc.manager":
    "È in corso una verifica amministrativa. Contatta il responsabile del servizio per maggiori informazioni.",
  "account.disabled.desc.postmaster":
    "È in corso una verifica amministrativa. Contatta il responsabile del servizio per maggiori informazioni.",
  "account.disabled.desc.vetting":
    "Per garantire un servizio di alta qualità ed evitare abusi da parte di malintenzionati, i nostri sistemi effettuano delle verifiche automatiche su tutti i nuovi utenti registrati. <br/><br/> In seguito alla tua registrazione sono state individuate delle anomalie che potrebbero essere causate dal fatto che ti stai connettendo mediante VPN o dall’inserimento di informazioni di contatto errate o non coerenti.",
  "account.disabled.title": "Il tuo account è temporaneamente bloccato",
  "account.disabled.titleVetting": "Abbiamo bisogno di maggiori dettagli sulla tua identità",
  "action.copied.password": "Password copiata",
  "action.copy": "Copia",
  "action.download.example.csv": "Scarica file .CSV di esempio",
  "action.download.verify.file": "Scaricare il file di verifica",
  "action.generateNewPassword": "Genera nuova password",
  "action.generateRandomPassword": "Genera password casuale",
  active: "attivi",
  activeF: "attive",
  "additionalservices.requested.desc":
    "Hai richiesto l'attivazione della personalizzazione {service}. <br/> A breve riceverai un'email con i dettagli della procedura.",
  "additionalservices.requested.title": "Richiesta effettuata",
  "admin.add.title": "Nuovo admin",
  "admins.list.header.dsc": "Gli Admin hanno accesso a tutte le impostazioni di ruoli e domini senza limitazioni.",
  "admins.list.header.title": "Admin",
  "alert.OTP.disabled": "OTP disabilitato",
  "alert.accountUpdatedSuccess": "Account aggiornato con successo",
  "alert.admin.created": "Admin creato",
  "alert.admin.deleted": "Admin eliminato",
  "alert.admin.updated": "Admin aggioranto",
  "alert.aliasDomainCreatedSuccess": "Dominio alias creato con successo",
  "alert.aliasEmailCreatedSuccess": "Email alias creato con successo",
  "alert.cannotEditWhileDisabled": "Non puoi modificare il dominio mentre è disabilitato",
  "alert.check.DNS.success": "Verifica messa in coda con successo",
  "alert.code.notValid": "Codice non valido",
  "alert.customer.created": "Customer creato",
  "alert.customer.disabled": "Impossibile abilitare perché il cliente è disabilitato",
  "alert.customer.updated": "Customer aggiornato",
  "alert.customization.deleted": "Personalizzazione eliminata",
  "alert.customizationCreatedSuccess": "Personalizzazione creata con successo",
  "alert.customizationUpdatedSuccess": "Personalizzazione aggiornata con successo",
  "alert.delegateDeletedSuccess": "Delegato cancellato con successo",
  "alert.delegateUpdatedSuccess": "Delegato aggiornato con successo",
  "alert.deliveryAccount.updated": "Account aggiornato",
  "alert.deliveryDomain.approvalSkip.success": "Approvazione saltata con successo",
  "alert.deliveryDomain.updated": "Dominio aggiornato",
  "alert.deliveryDomain.verification.fail": "Verifica fallita. Controlla i parametri di verifica.",
  "alert.deliveryDomain.verification.success": "Verifica completata con successo",
  "alert.destinations.updated": "Destinazioni aggiornate",
  "alert.domain.problem": "Abbiamo riscontrato un problema con questo dominio ti preghiamo di contattarci",
  "alert.domainCreatedSuccess": "Dominio creato con successo",
  "alert.domainUpdateSuccess": "Dominio aggiornato con successo",
  "alert.emailCreatedSuccess": "Email account creato con successo",
  "alert.emailUpdatedSuccess": "Email account modificato con successo",
  "alert.error.validation": "Errore di validazione",
  "alert.import.deleted": "Importazione eliminata",
  "alert.importCreatedSuccess": "Importazione aggiunta con successo",
  "alert.invalidFileCSVFormat": "Puoi eseguire l'upload solo di file .txt o .csv",
  "alert.invalidFileImageFormat": "Puoi eseguire l'upload solo di file .png o .jpeg",
  "alert.ipAddressAlreadyListed": "{ip} è già presente in lista",
  "alert.ipAddressInvalid": "{ip} non è un indirizzo valido",
  "alert.loginSuccess": "Login effettuato con successo",
  "alert.managerCreatedSuccess": "Manager creato con successo",
  "alert.managerDeletedSuccess": "Manager cancellato con successo",
  "alert.managerUpdatedSuccess": "Manager aggiornato con successo",
  "alert.migration.deleted": "Migrazione eliminata",
  "alert.migration.options.uploaded": "Migration Option uploaded",
  "alert.migrationCreateSuccess": "Migrazione aggiunta con successo",
  "alert.missingFile": "Devi effettuare l'upload di un file .txt o .csv",
  "alert.mxAlreadyExists": "Esiste già questa coppia di indirizzi",
  "alert.operationError": "Errore durante l'operazione",
  "alert.operationSuccess": "Modifiche applicate con successo",
  "alert.option.deleted": "Opzione eliminata",
  "alert.order.deleted": "Ordine eliminato",
  "alert.orderUpdatedFailed": "Aggiornamento dell'ordine fallito",
  "alert.orderUpdatedSuccess": "Ordine aggiornato con successo",
  "alert.orders.errorOnNew": "Errore nell'inserimento dell'ordine",
  "alert.otpInvalid": "OTP non valido",
  "alert.otpValid": "OTP valido",
  "alert.ownershipCheckFail": "Verifica della proprietà fallita",
  "alert.ownershipCheckSuccess": "Verifica della proprietà completata, dominio in coda per l'attivazione",
  "alert.ownershipEmailSent": "Email inviata a ",
  "alert.password.updated": "Password aggiornata",
  "alert.registration.completed": "Registrazione completata",
  "alert.resetEmailSended": "Email inviata, controlla la tua posta e segui le istruzioni",
  "alert.session.exiped": "Sessione scaduta, riprova",
  "alert.ssoError": "Il link non è valido",
  "alert.successfullyCopied": "Copiato",
  "alert.suppressionList.edit.success": "Lista di soppressione aggiornata correttamente",
  "alert.teamMemberCreatedSuccess": "Team member creato con successo",
  "alert.teamMemberDeletedSuccess": "Team member cancellato con successo",
  "alert.teamMemberUpdatedSuccess": "Team member aggiornato con successo",
  "alert.ticket.sent": "Ticket inviato",
  "alert.validationFailed": "Validazione fallita",
  "alert.verificationDKIMFailed": "Verifica fallita, controlla la configurazione e riprova",
  "alert.verificationFailed": "Verifica fallita",
  "alert.verificationSuccess": "Verifica avvenuta con successo",
  "alert.wrong": "Qualcosa è andato storto",
  "alert.wrong.contactUs": "Qualcosa è andato storto, contattaci",
  all: "Tutte",
  "archive.add.desc.step1":
    "Seleziona gli email account su cui attivare l’archivio. <b>Il numero di account su cui è possibile attivare l’archivio varia in base alle impostazioni del dominio</b>.",
  "archive.add.desc.step2":
    "Imposta il periodo di conservazione predefinito per i messaggi degli account sottoposti ad archiviazione. <b>I messaggi la cui cui data supera il periodo di conservazione scelto verranno automaticamente cancellati dall’archivio</b>.",
  "archive.add.desc.step3":
    "Imposta il periodo di conservazione predefinito per i nuovi account del dominio. <b>L'archivio verrà attivato automaticamente sui nuovi account fino al raggiungimento del numero di archivi disponibili</b>, in base alle impostazioni del dominio.",
  "archive.add.desc.step4":
    "L’attivazione dell'archivio è immediata. Il costo verrà calcolato in base al tipo di fatturazione del tuo account.",
  "archive.add.desc.step5":
    "L'archivio è stato attivato con successo. Ti è stata inviata una e-mail con le istruzioni per gestire il sistema di archiviazione.<br/>Nella <b>prossima fattura</b> troverai la voce <code>Archivio</code> relativa al servizio.",
  "archive.add.title.step1": "Nuovo archivio",
  "archive.add.title.step2": "Conservazione archivio",
  "archive.add.title.step3": "Archivio nuovi account",
  "archive.add.title.step4": "Riepilogo nuovo archivio",
  "archive.add.title.step5": "Archivio attivato",
  "archive.firstView.desc":
    "Archivia e conserva le tue email in modo automatico, sicuro e trasparente.<br/>Archivio è un <b>servizio aggiuntivo a pagamento</b> che salva e conserva copia di tutti i messaggi inviati e ricevuti totalmente in cloud, senza software o plugin di installazione.<br/><br/>I messaggi archiviati sono disponibili in sola lettura e vengono conservati per un periodo massimo di 10 anni.<br/>É possibile importare e archiviare il proprio storico messaggi.<br/><br/>L’attivazione del servizio Archivio è immediata e il costo viene calcolato in base al piano di pagamento scelto.",
  "archive.firstView.legalAd":
    "Prima di attivare Archivio è bene consultare un esperto in materia legale al fine di utilizzare il servizio a norma di legge per la propria azienda.<br/>Se necessario informare i propri dipendenti sul funzionamento e sui requisiti legali del servizio.",
  "archive.firstView.noArchive": "Non hai archivi disponibili per l'attivazione.",
  "archive.firstView.title": "Attiva archivio",
  "archive.import.faileMsg":
    "Ci sono stati alcuni problemi nella procedura di importazione.<br />Contattaci per maggiori informazioni.",
  "archive.import.loadingMsg":
    "<b>Importazione in corso.</b><br/>L’operazione può richiedere alcune ore. Riceverai una email di conferma al termine della procedura.",
  "archive.import.successMsg":
    "<b>L’importazione è avvenuta con successo.</b><br />Troverai i messaggi suddivisi per anno, ordinanti in inviati e ricevuti, come da te scelto.",
  "archive.import.warningMsg": "L'importazione può essere effettuata una sola volta",
  "archive.list.header.dsc":
    "Archivio consente di conservare, ricercare ed esportare tutti i messaggi in entrata e in uscita di un email account fino a 10 anni senza limiti di spazio.",
  "archive.list.header.title": "Archivio",
  "audits.list.header.dsc":
    "Il Registro elenca tutte le attività degli utenti relative alla gestione e all'utilizzo dei servizi.",
  "audits.list.header.title": "Registro",
  "banner.tryDelivery.cta": "Prova gratis il servizio",
  "banner.tryDelivery.desc":
    "      Il servizio <b>Email Delivery</b> è dedicato all’invio tramite il protocollo SMTP di grandi volumi di messaggi email, promozionali e transazionali.",
  "banner.tryDelivery.title": "Hai bisogno di inviare di più?",
  "beta.delivery.accounts.add.modal.contentMessage": "Per poter utilizzare l'utenza devi associarle almeno un dominio.",
  "beta.delivery.accounts.add.modal.info": "Riceverai un'email con il riepilogo dei dati.",
  "beta.delivery.accounts.add.modal.title": "Utenza attivata correttamente",
  "beta.delivery.accounts.credentials.modal.backButton": "Torna al riepilogo",
  "beta.delivery.accounts.credentials.modal.forwardButton": "Vai alla lista utenze",
  "beta.delivery.accounts.step2.warningMsg":
    "Nella versione Beta è possibile sottoscrivere solamente il piano Free Trial con 5000 invii mensili",
  "butto.info.hide": "Riduci",
  "butto.info.show": "Dettagli",
  "button.HTMLfile": "Genera file .HTML",
  "button.active": "Attiva",
  "button.add": "Aggiungi",
  "button.add.address": "Indirizzo",
  "button.add.customer": "Customer",
  "button.add.customization": "Personalizzazione",
  "button.add.delegate": "Delegato",
  "button.add.toList": "Aggiungi alla lista",
  "button.addAdmin": "Admin",
  "button.addAlias": "Dominio alias",
  "button.addAliasEmail": "Email alias",
  "button.addArchive": "Archivio",
  "button.addDomain": "Dominio",
  "button.addDomainFull": "Aggiungi Dominio",
  "button.addEmail": "Email account",
  "button.addManager": "Manager",
  "button.addTeamMember": "Team member",
  "button.advanced.domainInfo.hide": "Nascondi informazioni estese",
  "button.advanced.domainInfo.show": "Mostra informazioni estese",
  "button.advanced.filters.hide": "Nascondi filtri",
  "button.advanced.filters.show": "Filtri avanzati",
  "button.approveDomain": "Approva e attiva il dominio",
  "button.assignAccountOrDomain": "Modifica le risorse gestite",
  "button.back": "Indietro",
  "button.back.domains": "Torna ai domini",
  "button.backCustomers": "Torna a lista clienti",
  "button.backOrder": "Torna all'ordine",
  "button.buy": "Acquista",
  "button.buyExtraDelivery": "Acquista messaggi extra",
  "button.buyMailboxes": "Acquista caselle email",
  "button.buyPlan": "Acquista un piano",
  "button.cancel": "Annulla",
  "button.change": "Cambia",
  "button.changePlan": "Cambia piano",
  "button.checkOTP": "Verifica OTP",
  "button.close": "Chiudi",
  "button.confirm": "Conferma",
  "button.contactUs": "Contattaci",
  "button.continue": "Continua",
  "button.convertMonthly": "Converti a mensile",
  "button.copy": "Copia",
  "button.create": "Crea",
  "button.createAccount": "Crea utenza",
  "button.createDelegate": "Crea delegato",
  "button.createDomain": "Crea dominio",
  "button.days": "Giorni",
  "button.delete": "Elimina",
  "button.delete.deliveryAccount": "Elimina utenza",
  "button.delete.domain": "Elimina dominio",
  "button.deleteOrder": "Elimina ordine",
  "button.deliveryWaitlistAccept": "Sblocca accesso al servizio",
  "button.details.hide": "Nascondi",
  "button.details.show": "Dettagli",
  "button.disable": "Disattiva",
  "button.disableDKIM": "Disattiva DKIM",
  "button.disableOTP": "Disattiva OTP",
  "button.docs": "Documentazione",
  "button.download.report": "Scarica report",
  "button.edit": "Modifica",
  "button.enable": "Attiva",
  "button.enableDKIM": "Attiva DKIM",
  "button.enableOTP": "Abilita OTP",
  "button.expandTable": "Vedi tutto",
  "button.export.exportSuppressionListCompleted": "Esportazione completata",
  "button.export.exportingSuppressionList": "Creando il file...",
  "button.export.suppressionList": "Esporta lista di soppressione",
  "button.exportCSV": "Esporta CSV",
  "button.fillTheForm": "Compila il form",
  "button.filter": "Filtra",
  "button.force.change": "Forza cambio",
  "button.forgottenPassword": "Password dimenticata?",
  "button.generate.code": "Genera codice",
  "button.generate.password": "Genera nuova password",
  "button.generate.token": "Genera token",
  "button.goToArchive": "Gestisci archivio",
  "button.goToHome": "Torna alla home",
  "button.goToSettings": "Vai alle impostazioni",
  "button.goToVerification": "Vai alla verifica",
  "button.hide": "Nascondi",
  "button.import": "Importa",
  "button.import.list": "Importa lista",
  "button.insert": "Inserisci",
  "button.loadMore": "Carica altri",
  "button.loading": "Caricamento",
  "button.login": "Log in",
  "button.logout": "Logout",
  "button.manage.delegates": "Gestisci delegati",
  "button.manage.domains": "Gestisci domini",
  "button.migrate": "Aggiungi Migrazione",
  "button.modifyPlan.cancel": "Annulla richiesta di modifica",
  "button.modifyPlan.monthly": "Modifica messaggi inclusi nel piano",
  "button.moreMessages": "Aumenta numero messaggi",
  "button.mtmRestore.accept": "Accetta richiesta",
  "button.mtmRestore.deny": "Rifiuta richiesta",
  "button.new.signature": "Nuova firma",
  "button.new.ticket": "Nuovo ticket",
  "button.newDomainArchive": "Attiva archivio",
  "button.newImport": "Importazione",
  "button.newMigration": "Migrazione",
  "button.next": "Avanti",
  "button.ok": "Ok",
  "button.openIn.newWindow": "Apri in nuova tab",
  "button.order": "Ordina",
  "button.order.cancel": "Annulla richiesta",
  "button.passwordChange": "Cambia password",
  "button.passwordRecovery": "Recupera password",
  "button.passwordReset": "Rest password",
  "button.passwordSet": "Imposta password",
  "button.pay": "Paga",
  "button.pickPlan": "Scegli un piano",
  "button.regenerate.code": "Rigenera codice",
  "button.remove": "Rimuovi",
  "button.remove.link": "Rimuovi link",
  "button.requestAccess": "Richiedi l'accesso",
  "button.reset": "Reset",
  "button.reset.token": "Reset token",
  "button.resetProcedure": "Reset procedura",
  "button.restore.deliveryAccount": "Ripristina abbonamento",
  "button.run.migration.first": "Esegui 1°",
  "button.run.migration.second": "Esegui 2°",
  "button.save": "Salva",
  "button.saveApply": "Salva e applica",
  "button.search": "Cerca",
  "button.see.proforma": "Paga ora",
  "button.send.ticket": "Invia ticket",
  "button.sendVerifyEmail": "Invia email di verifica",
  "button.servicesAndBilling": "Servizi e Fatture",
  "button.setSignature": "Applica firma",
  "button.show": "Mostra",
  "button.showDNSConfig": "Mostra parametri DNS",
  "button.showLog": "Mostra log",
  "button.showServerResponse": "Mostra risposta server",
  "button.skipDeliveryDns": "Attiva senza verificare DNS",
  "button.skipOwnershipCheck": "Salta ownership check",
  "button.startImport": "Inizia importazione",
  "button.understood": "Ho capito",
  "button.update": "Aggiorna",
  "button.upgradeAccounts": "Aggiunta email account",
  "button.upgradePlan": "Upgrade piano",
  "button.verify": "Verifica",
  "button.verifyDKIM": "Verifica DKIM",
  "button.verifyDNS": "Verifica DNS",
  "button.verifyMX": "Verifica MX",
  "buttonIcons.add.image": "Inserisci immagine",
  "buttonIcons.bold": "Grassetto",
  "buttonIcons.delete": "Elimina",
  "buttonIcons.edit": "Modifica",
  "buttonIcons.insert.HTML": "Inserisci HTML",
  "buttonIcons.insert.link": "Inserisci link",
  "buttonIcons.italic": "Corsivo",
  "buttonIcons.remove.formatting": "Rimuovi formattazione",
  "buttonIcons.remove.link": "Rimuovi link",
  "buttonIcons.strike": "Barrato",
  "buttonIcons.underline": "Sottolineato",
  "confirmationModal.text.delete.admin":
    "Stai tentando di eliminare <code>{nameAdmin}</code>.<br/><b>L'operazione non è reversibile.</b>",
  "confirmationModal.text.delete.customer":
    "Stai tentando di eliminare <code>{customerName}</code>.<br/>Cancellando il cliente tutte le sue risorse verranno cancellate.<br/><b>L'operazione non è reversibile.</b>",
  "confirmationModal.text.delete.domainAlias":
    "Stai tentando di eliminare il dominio alias <code>{domainAliasName}</code>.<br/><b>L'operazione non è reversibile.</b>",
  "confirmationModal.text.delete.domains":
    "Stai tentando di eliminare <code>{domainName}</code>.<br/>Cancellando il dominio perderai tutti gli email account e gli alias a esso collegati.<br/><b>L'operazione non è reversibile.</b>",
  "confirmationModal.text.delete.emailAlias":
    "Stai tentando di eliminare l'email alias <code>{emailAliasName}</code>.<br/><b>L'operazione non è reversibile.</b>",
  "confirmationModal.text.delete.order":
    "Procedendo all’annullamento tutti i dati immessi durante la procedura verranno cancellati e sarà necessario procedere con un nuovo ordine.",
  "confirmationModal.text.delivery.samePlan":
    "Il piano è lo stesso di quello attuale, scegli un piano diverso per procedere",
  "confirmationModal.title.delete.admin": "Elimina admin",
  "confirmationModal.title.delete.domainAlias": "Elimina dominio alias",
  "confirmationModal.title.delete.emailAlias": "Elimina email alias",
  "confirmationModal.title.delete.order": "Elimina ordine",
  "confirmationModal.title.delete.suppressionList": "Rimuovi da lista di soppressione",
  "confirmationModal.title.delivery.samePlan": "Attenzione",
  "confirmationModal.title.delte.customer": "Elimina cliente",
  "confirmationModal.title.delte.domain": "Elimina dominio",
  "customer.add.title": "Nuovo cliente",
  "customers.list.header.dsc":
    "I Clienti possono gestire domini e altri ruoli di amministrazione nei limiti loro assegnati.",
  "customers.list.header.title": "Clienti",
  "customizations.add.domains.desc":
    "Imposta una personaliazzione per i domini che preferisci. Il logo e le altre informazioni saranno visualizzati in tutti i tuoi servizi collegati ai domini selezionati.",
  "customizations.add.domains.title": "Nuova personalizzazione domini",
  "customizations.add.general.desc":
    "Imposta una personalizzazione generale da applicare a tutti i domini che gestisci, se non presente una personalizzazione specifica per singolo dominio. <b>È possibile inserire una sola personalizzazione generale.</b>",
  "customizations.add.general.title": "Nuova personalizzazione generale",
  "customizations.collaboration": "in collaborazione con",
  "customizations.edit.domains.title": "Modifica personalizzazione domini",
  "customizations.edit.general.title": "Modifica personalizzazione generale",
  "customizations.list.header.dsc":
    "Le personalizzazioni consentono di personalizzare i nostri servizi con il proprio logo e nome aziendale.",
  "customizations.list.header.title": "Personalizzazioni",
  "customizations.show.desc.domains":
    "Le personalizzazioni per dominio vengono applicate solo a specifici domini (con piano professional o enterprise).  Il logo e le altre informazioni saranno visualizzati in tutti i tuoi servizi collegati ai domini selezionati.",
  "customizations.show.desc.general":
    "La personalizzazione generale viene applicata a tutti i domini, se non presente una personalizzazione specifica per singolo dominio.  Il logo e le altre informazioni saranno visualizzati in tutti i servizi. <b>È possibile inserire una sola personalizzazione generale.</b>",
  "customizations.show.desc.managers":
    "Queste sono le impostazioni generali create dai tuoi manager. La gestione è completamente affidata a loro",
  "dashboard.chart.title.alias.domain.active": "Domini alias attivati",
  "dashboard.chart.title.alias.email.active": "Email alias attivati",
  "dashboard.chart.title.domains.active": "Domini attivati",
  "dashboard.chart.title.emails.active": "Email account attivati",
  "dashboard.chart.title.maxQuota.email": "Email account per massima quota",
  "dashboard.chart.title.topQuota.domain": "Top domini spazio occupato",
  "dashboard.deliveryAnalytics.title": "Dettaglio degli invii effettuati",
  "dashboard.extraDelivery.desc":
    "I messaggi extra permettono di continuare ad inviare anche nel caso in cui vengano terminati i messaggi inclusi nell'abbonamento. Non hanno scadenza e possono essere utilizzati fintanto che l'utenza rimane attiva.",
  "dashboard.extraDelivery.title": "Messaggi email extra",
  "dashboard.label.accounts_disabled": "Utenze inattive",
  "dashboard.label.accounts_enabled": "Utenze attive",
  "dashboard.label.alias_domains": "Domini alias",
  "dashboard.label.alias_email_accounts": "Email alias",
  "dashboard.label.customers_disabled": "Clienti disattivati",
  "dashboard.label.customers_enabled": "Clienti attivi",
  "dashboard.label.domainActivations": "Attivazioni domini",
  "dashboard.label.domainAliasActivations": "Attivazioni domini alias",
  "dashboard.label.domains_disabled": "Domini disattivati",
  "dashboard.label.domains_enabled": "Domini attivi",
  "dashboard.label.domains_only_postmaster": "Domini senza Email Account",
  "dashboard.label.emailAccountsPerQuota": "Account per quota",
  "dashboard.label.emailActivations": "Attivazioni account",
  "dashboard.label.emailAliasActivations": "Attivazioni email alias",
  "dashboard.label.email_accounts_100gb_disabled": "Account 100GB disattivati",
  "dashboard.label.email_accounts_100gb_enabled": "Account 100GB attivi",
  "dashboard.label.email_accounts_25gb_disabled": "Account 25GB disattivati",
  "dashboard.label.email_accounts_25gb_enabled": "Account 25GB attivi",
  "dashboard.label.email_accounts_50gb_disabled": "Account 50GB disattivati",
  "dashboard.label.email_accounts_50gb_enabled": "Account 50GB attivi",
  "dashboard.label.email_accounts_8gb_disabled": "Account 8GB disattivati",
  "dashboard.label.email_accounts_8gb_enabled": "Account 8GB attivi",
  "dashboard.label.email_accounts_archive_disabled": "Archivio disattivati",
  "dashboard.label.email_accounts_archive_enabled": "Archivio attivi",
  "dashboard.label.mail_overquota": "Account overquota",
  "dashboard.label.managers": "Manager",
  "dashboard.label.postmaster_domain_disabled": "Postmaster disattivati",
  "dashboard.label.postmaster_domain_enabled": "Postmaster attivi",
  "dashboard.label.team_members": "Team member",
  "dashboard.label.top10DomainsQuota": "Top 10 domini overquota",
  "dashboard.label.top10EmailsQuota": "Top 10 account overquota",
  "dashboard.list.header.title": "Dashboard",
  "dashboard.messagesDetails.desc": "Dettaglio dei messaggi processati inviati dall'utenza e divisi per giorni.",
  "dashboard.messagesDetails.title": "Messaggi inviati dall'utenza",
  "dashboard.messagesPerDomain.desc": "Dettaglio dei messaggi processati inviati dai domini associati all'utenza.",
  "dashboard.messagesPerDomain.title": "Messaggi inviati dai domini",
  "dashboard.planDetails.free.content.title": "Abbonamento Free",
  "dashboard.planDetails.monthly.content.title": "Abbonamento Mensile",
  "dashboard.planDetails.prepaid.content.title": "Pacchetto prepagato",
  "ddMenu.cancel": "Annulla",
  "ddMenu.delete": "Elimina",
  "ddMenu.disable": "Disattiva",
  "ddMenu.enable": "Riattiva",
  "ddMenu.logout": "Logout",
  "ddMenu.manage.account": "Gestisci account",
  "ddMenu.settings": "Impostazioni",
  "ddMenu.suppressionListDeliver": "Abilita consegna",
  "ddMenu.suppressionListDontDeliver": "Blocca consegna",
  "ddMenu.tour": "Tour",
  "delegate.add.desc.step1":
    "Inserisci le informazioni di contatto dell'utente che vuoi autorizzare a prendere visione dell'archivio.",
  "delegate.add.desc.step2":
    "Imposta la data di scadenza dell'autorizzazione del delegato e l'intervallo temporale di archiviazione di cui potrà prendere visione. <b/>Alla data scelta l'autorizzazione verrà automaticamente revocata e il delegato verrà disattivato</b>.",
  "delegate.add.desc.step3":
    "Seleziona gli account di cui il delegato potrà prendere visione. È possibile autorizzare il delegato alla visione degli account di più domini.<br/><br/><b>Oggetto:</b> visione di mittente/destinatario, oggetto e data dei messaggi<br/><b>Tutto:</b> visione completa del contenuto dei messaggi<br/><b>Ignora:</b> accesso ai contenuti non autorizzato",
  "delegate.add.desc.step4":
    "Il delegato sarà subito attivo. Verrà inviata una email all’utente indicato con le credenziali e le istruzioni per l’accesso. Il delegato cesserà automaticamente di esistere alla scadenza scelta.",
  "delegate.add.desc.step5":
    "Il delegato <b>{name}</b> è stato creato con successo. Una mail con le istruzioni per accedere al sistema di archiviazione è stata inviata a <code>{emailAddress}</code>.<br/><br/>UserID del delegato: <code>{userID}</code>",
  "delegate.add.title.step1": "Nuovo delegato",
  "delegate.add.title.step2": "Limiti temporali",
  "delegate.add.title.step3": "Accesso contenuti",
  "delegate.add.title.step4": "Riepilogo nuovo delegato",
  "delegate.add.title.step5": "Delegato creato",
  "delegates.firstView.desc":
    "Consenti a chi vuoi di prendere visione dei messaggi archiviati.<br/>I delegati sono utenti autorizzati a prendere visione, in sola lettura, di parte o di tutto il contenuto dei messaggi archiviati di una o più email account, in un intervallo temporale definito.<br/><br/>L'account verrà rimosso automaticamente se tutti gli email account a cui è stato delegato saranno rimossi.<br/><b>La creazione di un delegato non è obbligatoria per utilizzare l'archivio.</b>",
  "delegates.firstView.title": "Abilita delegati",
  "delegates.firstView.warningMsg": "È necessario attivare l'archivio su almeno una casella mail.",
  "delegates.list.header.dsc":
    "I delegati sono utenti autorizzati ad accedere al contenuto di uno o più archivi entro determinati limiti.",
  "delegates.list.header.title": "Delegati",
  "delivery.accessRequest.step1.desc":
    "Email Delivery è il servizio di Qboxmail pensato per l'invio di grandi volumi di messaggi email tramite il protocollo SMTP. Il servizio è pensato per i clienti che hanno necessità di inviare messaggio email direttamente dai loro applicativi quali e-commerce, software gestionali e di fatturazione, applicativi di marketing per l'invio di newsletter, semplicemente impostando il tradizionale protocollo SMTP. Il servizio è al momento disponibile gratuitamente in versione beta",
  "delivery.accessRequest.step1.docsLink": "Scopri di più...",
  "delivery.accessRequest.step1.servicesOptions.none": "Nessuno",
  "delivery.accessRequest.step1.servicesOptions.other": "Altro",
  "delivery.accessRequest.step1.servicesOptions.server": "Server dedicato",
  "delivery.accessRequest.step1.title": "Email Delivery",
  "delivery.accessRequest.step2.desc":
    "Rispondi alle seguenti domande per richiedere l'accesso al servizio di Email Delivery in versione beta e gratuita. Verrai inserito nella lista di attesa e ti verrà comunicato quando l'accesso sarà disponibile.",
  "delivery.accessRequest.step2.similarServices.title": "Hai già utilizzato un altro servizio simle?",
  "delivery.accessRequest.step2.title": "Richiesta di accesso al servizio di Email Delivery",
  "delivery.accessRequest.step2.totalEmailsEstimate.placeholder": "Indica una stima approssimativa",
  "delivery.accessRequest.step2.totalEmailsEstimate.title": "Quante email pensi di inviare in un mese?",
  "delivery.accessRequest.step2.type.title": "Quale tipologia di messaggi email vorresti inviare?",
  "delivery.accessRequest.step3.desc":
    "Abbiamo preso in carico la tua richiesta e ti faremo sapere il prima possibile se soddisfi i requisiti per accedere al servizio di Email Delivery in versione beta e gratuita.",
  "delivery.accessRequest.step3.title": "Grazie per aver richiesto l'accesso",
  "delivery.accessRequest.warningUnpaid":
    "Solo i clienti con un piano a pagamento attivo possono accedere al programma beta",
  "delivery.account.status.disabled": "Disattivata da sistema",
  "delivery.account.status.disabledByCustomer": "Disattivata",
  "delivery.account.status.enabled": "Attiva",
  "delivery.account.status.scheduledDeleting": "Attiva",
  "delivery.account.status.updating": "In aggiornamento",
  "delivery.account.status.waitingCustomerApproval": "In attesa di approvazione",
  "delivery.account.status.waitingCustomerApprovalFull": "In attesa di approvazione del fornitore",
  "delivery.account.status.waitingPayment": "In attesa di pagamento",
  "delivery.accounts.add.extraDelivery.packages.title": "Quanti pacchetti vuoi acquistare?",
  "delivery.accounts.add.step1.desc":
    "Crea una nuova utenza sottoscrivendo un piano di invio. Una volta creata dovrai associarle almeno un dominio autorizzato all'invio.",
  "delivery.accounts.add.step1.description.desc":
    "Inserisci una descrizione che ti sarà utile a ricordare per cosa utilizzare questa utenza (es.“Newsletter hotel”, “Conferma prenotazioni hotel”)",
  "delivery.accounts.add.step1.description.title": "Descrizione personale",
  "delivery.accounts.add.step1.title": "Nuova utenza",
  "delivery.accounts.add.step1.type.both.label": "Entrambi",
  "delivery.accounts.add.step1.type.desc": "Seleziona il tipo di invio che vuoi effettuare con l'utenza",
  "delivery.accounts.add.step1.type.marketing.desc":
    "Le email promozionali sono email inviate a destinatari multipli (potenziali clienti o clienti esistenti) per scopi promozionali, come ad esempio campagne email pubblicitarie e di vendita, newsletter, ecc...",
  "delivery.accounts.add.step1.type.marketing.label": "Email promozionali",
  "delivery.accounts.add.step1.type.title": "Tipologia",
  "delivery.accounts.add.step1.type.transaction.desc":
    "Le email transazionali sono inviate a un destinatario specifico per confermare un'azione o notificare un evento, come ad esempio conferme d'ordine, fatture, ecc..",
  "delivery.accounts.add.step1.type.transaction.label": "Email transazionali",
  "delivery.accounts.add.step2.betaBanner.description":
    "Nella versione Beta è possibile sottoscrivere solamente il piano Free Trial con 5000 invii mensili.",
  "delivery.accounts.add.step2.betaBanner.title": "SOLO PIANO FREE TRIAL DISPONIBILE",
  "delivery.accounts.add.step2.desc": "Selezionare il piano che regolerà l'utenza e il numero di invii.",
  "delivery.accounts.add.step2.freePlanPriceRecap": "Gratis",
  "delivery.accounts.add.step2.plan.free.label": "Free trial",
  "delivery.accounts.add.step2.plan.monthly.label": "Abbonamento mensile",
  "delivery.accounts.add.step2.plan.msg": "Seleziona il tipo di piano",
  "delivery.accounts.add.step2.plan.prepaid.label": "Pacchetto prepagato",
  "delivery.accounts.add.step2.plan.title": "Tipologia",
  "delivery.accounts.add.step2.priceRecapLabel": "Prezzo",
  "delivery.accounts.add.step2.title": "Piano utenza",
  "delivery.accounts.add.step2.volume.label": "TODO: Invia 5000 email al mese per 12 mesi",
  "delivery.accounts.add.step2.volume.msg": "Quante email vuoi inviare al mese?",
  "delivery.accounts.add.step2.volume.title": "Numero di invii",
  "delivery.accounts.add.step3.billRecap.message1":
    "Il prezzo indicato si riferisce al costo del servizio per l'intero mese. L'importo esatto della prima fattura, che riceverai via email, verrà calcolata in base alla data di completamento dell’ordine.",
  "delivery.accounts.add.step3.billRecap.message2":
    "Il costo dell'abbonamento mensile non comprende il costo degli invii extra. Gli invii extra verranno addebitati in fattura solo se utilizzati, al prezzo di € 1,00 ogni 1000 invii.",
  "delivery.accounts.add.step3.billRecap.title": "Canone mensile",
  "delivery.accounts.add.step3.desc": "Di seguito è riepilogata la configurazione scelta per l'utenza.",
  "delivery.accounts.add.step3.serviceRecap.plan": "Piano",
  "delivery.accounts.add.step3.serviceRecap.type": "Tipo invio",
  "delivery.accounts.add.step3.serviceRecap.volume": "Numero invii",
  "delivery.accounts.add.step3.title": "Riepilogo",
  "delivery.accounts.add.step4.desc":
    "Per poter utilizzare l'utenza che stai creando avrai bisogno del nome utente e della password indicati di seguito. Andranno inseriti nel tuo client di posta per effettuare l'accesso.",
  "delivery.accounts.add.step4.downloadAsCsv": "Scarica tutti i dati dell'utenza in formato .csv",
  "delivery.accounts.add.step4.title": "Nome utente e password",
  "delivery.accounts.add.step4.warningMsg":
    "Attenzione! È importante salvare la password in un luogo sicuro: in caso di smarrimento sarà possibile soltanto generarne una nuova.",
  "delivery.accounts.add.stepBillingInfo.desc":
    "Inserisci tutte le informazioni necessarie per la fatturazione del servizio.",
  "delivery.accounts.add.stepBillingInfo.title": "Dati di fatturazione",
  "delivery.accounts.add.stepCredentials.desc":
    "Per poter utilizzare questa utenza avrai bisogno del nome utente e della password indicati di seguito. Andranno inseriti nel tuo applicativo per effettuare l'accesso e inviare i messaggi.",
  "delivery.accounts.add.stepCredentials.downloadAsCsv": "Scarica tutti i dati dell'utenza in formato .csv",
  "delivery.accounts.add.stepCredentials.parameters": "Parametri",
  "delivery.accounts.add.stepCredentials.parametersSaved": "Ho salvato i parametri",
  "delivery.accounts.add.stepCredentials.title": "Configurazione per inviare",
  "delivery.accounts.add.stepCredentials.warningMsg":
    "Attenzione! È importante salvare la password in un luogo sicuro: in caso di smarrimento sarà possibile soltanto generarne una nuova.",
  "delivery.accounts.add.stepCustomerType.desc":
    "Indica se intendi utilizzare il servizio solo per te, per la tua azienda o se intendi acquistarlo per rivenderlo a terzi.",
  "delivery.accounts.add.stepCustomerType.title": "Tipologia cliente",
  "delivery.accounts.add.stepCustomerType.typeSelection.company.label": "Azienda",
  "delivery.accounts.add.stepCustomerType.typeSelection.private.label": "Privato [solo residenti in Italia]",
  "delivery.accounts.add.stepCustomerType.typeSelection.reseller.label": "Rivenditore",
  "delivery.accounts.add.stepCustomerType.typeSelection.title": "Seleziona la tipologia di cliente che ti rappresenta",
  "delivery.accounts.add.stepPaymentMethod.additionalBilling.title":
    "Specifica un contatto aggiuntivo per la ricezione delle fatture (facoltativo)",
  "delivery.accounts.add.stepPaymentMethod.credentials.desc": "Le tue credenziali di accesso all'area clienti sono:",
  "delivery.accounts.add.stepPaymentMethod.credentials.title": "Credenziali di accesso Area Clienti",
  "delivery.accounts.add.stepPaymentMethod.customerAreaCredentials.label":
    "Usa credenziali diverse per accedere all'area clienti",
  "delivery.accounts.add.stepPaymentMethod.customerAreaCredentials.password":
    "La password che usi per accedere al pannello",
  "delivery.accounts.add.stepPaymentMethod.desc":
    "Scegli il metodo di pagamento che più si adatta alle tue esigenze e scegli le credenziali di accesso al sistema di fatturazione",
  "delivery.accounts.add.stepPaymentMethod.payment.title": "Seleziona il metodo di pagamento",
  "delivery.accounts.add.stepPaymentMethod.title": "Metodo di pagamento",
  "delivery.accounts.add.stepPlan.betaBanner.description":
    "Nella versione Beta è possibile sottoscrivere solamente il piano Free Trial che include 5.000 invii mensili.",
  "delivery.accounts.add.stepPlan.betaBanner.title": "SOLO PIANO FREE TRIAL DISPONIBILE",
  "delivery.accounts.add.stepPlan.changeDesc":
    "All’attivazione del nuovo piano, <b>i messaggi residui del mese in corso verranno persi</b>.",
  "delivery.accounts.add.stepPlan.changeDescMonthToPrepaid":
    "I <b>messaggi email extra</b> sono disponibili solo per gli Abbonamenti mensili, se cambi tipologia di piano <b>perderai i messaggi extra residui</b>. <br/>All’attivazione del nuovo piano, <b>i messaggi residui del mese in corso verranno persi</b>.",
  "delivery.accounts.add.stepPlan.changeDescPrepaid":
    "Il nuovo pacchetto acquistato verrà sommato al saldo attuale. La scadenza verrà adeguata per tutti i messaggi residui.",
  "delivery.accounts.add.stepPlan.changeDescPrepaidToMonth":
    "All’attivazione del nuovo piano, <b>i messaggi residui verranno persi</b>.",
  "delivery.accounts.add.stepPlan.changeRecapCreditNext": "Il tuo prossimo saldo",
  "delivery.accounts.add.stepPlan.changeRecapCreditNow": "Il tuo saldo",
  "delivery.accounts.add.stepPlan.changeRecapTitleNext": "Il tuo prossimo piano",
  "delivery.accounts.add.stepPlan.changeRecapTitleNow": "Il tuo piano attuale",
  "delivery.accounts.add.stepPlan.desc": "Seleziona il piano che regolerà l'utenza e il numero di messaggi.",
  "delivery.accounts.add.stepPlan.disclaimer":
    "Una volta completato il pagamento il tuo piano attuale verrà terminato e perderai i messaggi residui. Avrai subito a disposizione il tuo nuovo piano.",
  "delivery.accounts.add.stepPlan.footerMsg":
    "I messaggi acquistati hanno una validità di 12 mesi; la scadenza viene prorogata in caso di acquisto successivo.",
  "delivery.accounts.add.stepPlan.freePlanPriceRecap": "Gratis",
  "delivery.accounts.add.stepPlan.monthlyNumberOfMessages": "Messaggi mensili",
  "delivery.accounts.add.stepPlan.monthlyPrice": "Prezzo mensile",
  "delivery.accounts.add.stepPlan.monthlyResellerPrice": "Prezzo mensile per rivenditori",
  "delivery.accounts.add.stepPlan.numberOfMessages": "Messaggi",
  "delivery.accounts.add.stepPlan.plan.free.label": "Free",
  "delivery.accounts.add.stepPlan.plan.monthly.label": "Abbonamento mensile",
  "delivery.accounts.add.stepPlan.plan.msg": "Seleziona il tipo di piano",
  "delivery.accounts.add.stepPlan.plan.prepaid.label": "Pacchetto prepagato",
  "delivery.accounts.add.stepPlan.plan.title": "Tipologia",
  "delivery.accounts.add.stepPlan.prepaid.volume.msg": "Quanti messaggi da inviare vuoi acquistare?",
  "delivery.accounts.add.stepPlan.price": "Prezzo",
  "delivery.accounts.add.stepPlan.priceRecapLabel": "Prezzo",
  "delivery.accounts.add.stepPlan.resellerPrice": "Prezzo per rivenditori",
  "delivery.accounts.add.stepPlan.title": "Piano utenza",
  "delivery.accounts.add.stepPlan.volume.label": "Invia 5000 email al mese per 12 mesi",
  "delivery.accounts.add.stepPlan.volume.msg": "Quante email vuoi inviare al mese?",
  "delivery.accounts.add.stepPlan.volume.title": "Numero di messaggi",
  "delivery.accounts.add.stepRecap.billRecap.message.monthly":
    "La cifra indicata si riferisce all'intero mese. L'importo esatto della prima fattura, che riceverai via email, verrà calcolato in base alla data di completamento dell'ordine.",
  "delivery.accounts.add.stepRecap.billRecap.message2":
    "Il costo dell'abbonamento mensile non comprende il costo dei messaggi email extra. I messaggi extra verranno addebitati in fattura solo se utilizzati, al prezzo di € 1,00 ogni 1000 invii.",
  "delivery.accounts.add.stepRecap.billRecap.title": "Canone mensile",
  "delivery.accounts.add.stepRecap.desc": "Di seguito è riepilogata la configurazione scelta per l'utenza.",
  "delivery.accounts.add.stepRecap.modal.info.free": "Riceverai un'email con il riepilogo dei dati.",
  "delivery.accounts.add.stepRecap.modal.info.pay":
    "Riceverai un'email con il riepilogo dell'ordine effettuato e con i dettagli per effettuare il pagamento. L'utenza verrà abilitata appena verrà registrato il pagamento.",
  "delivery.accounts.add.stepRecap.modal.title.free": "Utenza attivata correttamente",
  "delivery.accounts.add.stepRecap.modal.title.pay": "Ordine inserito",
  "delivery.accounts.add.stepRecap.serviceRecap.paymentType": "Metodo di pagamento",
  "delivery.accounts.add.stepRecap.serviceRecap.plan": "Piano",
  "delivery.accounts.add.stepRecap.serviceRecap.type": "Tipo invio",
  "delivery.accounts.add.stepRecap.serviceRecap.volume": "Numero invii",
  "delivery.accounts.add.stepRecap.title": "Riepilogo",
  "delivery.accounts.button.addNew": "Utenza",
  "delivery.accounts.confirmationModal.deleteAccount.message":
    "Stai tentando di eliminare l'utenza <code>{account}</code>",
  "delivery.accounts.confirmationModal.deleteAccount.title": "Elimina utenza",
  "delivery.accounts.dashboard.activities.accepted": "Presi in carico",
  "delivery.accounts.dashboard.activities.bounces": "Respinti",
  "delivery.accounts.dashboard.activities.delivered": "Consegnati",
  "delivery.accounts.dashboard.activities.desc": "Dettaglio dell'attività relativa ai messaggi inviati.",
  "delivery.accounts.dashboard.activities.enqueued": "In coda",
  "delivery.accounts.dashboard.activities.remainingMessages": "Messaggi residui",
  "delivery.accounts.dashboard.activities.suppressed": "Soppressi",
  "delivery.accounts.dashboard.activities.title": "Attività",
  "delivery.accounts.dashboard.details.desc": "Caratteristiche del piano attivato per l'utenza.",
  "delivery.accounts.dashboard.details.table.activationDate": "Attivo da",
  "delivery.accounts.dashboard.details.table.connectedDomains": "Domini associati",
  "delivery.accounts.dashboard.details.table.extraDelivery": "Invii extra",
  "delivery.accounts.dashboard.details.table.lastRenewal": "Ultimo rinnovo",
  "delivery.accounts.dashboard.details.table.nextRenewal": "Prossimo rinnovo",
  "delivery.accounts.dashboard.details.table.planVolumes": "Invii inclusi nel piano",
  "delivery.accounts.dashboard.details.table.title": "Contenuto",
  "delivery.accounts.dashboard.details.title": "Dettagli del piano",
  "delivery.accounts.detailsAndSecurity.bounceNotification.desc":
    "Gli avvisi di bounce vengono inviati al mittente per impostazione predefinita. È possibile riceverli a un indirizzo differente indicandolo qui.",
  "delivery.accounts.detailsAndSecurity.bounceNotification.label.custom": "Personalizza",
  "delivery.accounts.detailsAndSecurity.bounceNotification.label.toSender": "Indirizzo mittente messaggio",
  "delivery.accounts.detailsAndSecurity.bounceNotification.title": "Avviso di bounce",
  "delivery.accounts.detailsAndSecurity.credentials.desc":
    "Le credenziali dell'utenza vanno inserite nel tuo client di posta per effettuare l'accesso.",
  "delivery.accounts.detailsAndSecurity.credentials.title": "Credenziali",
  "delivery.accounts.detailsAndSecurity.enabledIps.desc":
    "Restringi l'accesso all'utenza solo agli indirizzi IP che ritieni sicuri.",
  "delivery.accounts.detailsAndSecurity.enabledIps.tableTitle": "Indirizzi IP autorizzati",
  "delivery.accounts.detailsAndSecurity.enabledIps.title": "IP abilitati",
  "delivery.accounts.detailsAndSecurity.ignoreSuppressionList.desc":
    "Scegli se ignorare la lista di soppressione quando invii messaggi con questa utenza.",
  "delivery.accounts.detailsAndSecurity.ignoreSuppressionList.hint":
    "Attivando questa impostazione i messaggi vengono inviati anche agli indirizzi email presenti nella lista di soppressione. La lista di soppressione continuerà ad essere popolata.",
  "delivery.accounts.detailsAndSecurity.ignoreSuppressionList.title": "Lista di soppressione",
  "delivery.accounts.detailsAndSecurity.newPassword.modal.desc":
    "Generando una nuova password quella attuale verrà sostituita. Ricordati di aggiornare la password qualora l'avessi inserita in applicativi collegati alla tua utenza.<br/><br/>Una volta generata la nuova password ricordati di <b>copiarla e salvarla</b> perchè non sarà più possibile visualizzarla successivamente.",
  "delivery.accounts.detailsAndSecurity.newPassword.modal.title": "Conferma generazione nuova password",
  "delivery.accounts.detailsAndSecurity.personalDescription.desc":
    "Inserisci una breve descrizione personalizzata per identificare più facilmente l'utenza.",
  "delivery.accounts.detailsAndSecurity.personalDescription.label": "Descrizione",
  "delivery.accounts.detailsAndSecurity.personalDescription.title": "Descrizione personale",
  "delivery.accounts.domains.connectedDomains.desc":
    "Lista dei domini con i quali l'utenza è autorizzata ad inviare email.",
  "delivery.accounts.domains.connectedDomains.exceededMsg":
    "Limite di domini superato. Hai associato {current} domini.",
  "delivery.accounts.domains.connectedDomains.modalLabel": "Dominio selezionato",
  "delivery.accounts.domains.connectedDomains.modalMessage":
    "Seleziona il dominio da associare all'utenza. È possibile associare un dominio per volta.",
  "delivery.accounts.domains.connectedDomains.title": "Associazione utenza-domini",
  "delivery.accounts.domains.connectedDomains.warningMsg": "È possibile associare un massimo di {domains} domini",
  "delivery.accounts.domains.noAssociatedDomain.desc": "Nessun dominio associato all'utenza",
  "delivery.accounts.domains.noExistingDomain.desc": "Devi creare un dominio per poterlo associare a questa utenza",
  "delivery.accounts.domains.noExistingDomain.msg": "Crea un dominio",
  "delivery.accounts.domainsPage.button.bindDomain": "Associa un dominio",
  "delivery.accounts.emptyList.noRecordsMsg":
    "Per poter effettuare invii massivi è necessario creare almeno un’utenza e associarle almeno un dominio.",
  "delivery.accounts.extradelivery.minimumOrder": "Ordine minimo 5 pacchetti",
  "delivery.accounts.extradelivery.purchase": "1 pacchetto = 1.000 messaggi extra",
  "delivery.accounts.extradelivery.stepRecap.desc": "Di seguito trovi il riepilogo dell'operazione.",
  "delivery.accounts.extradelivery.stepRecap.table.title": "Messaggi extra per l'utenza",
  "delivery.accounts.extradelivery.stepRecap.title": "Riepilogo e pagamento",
  "delivery.accounts.extradelivery.title": "Acquista pacchetti di messaggi extra",
  "delivery.accounts.freeTrial.warningMsg":
    "Il piano free può essere richiesto per una sola utenza alla volta. Ogni utenza può avere il piano Free una sola volta.",
  "delivery.accounts.label.availableMessages": "Messaggi Disponibili",
  "delivery.accounts.label.customerName": "Cliente",
  "delivery.accounts.label.deletingOn": "In cancellazione",
  "delivery.accounts.label.domainsCount": "Domini associati",
  "delivery.accounts.label.expirationPrepaid": "Scadenza",
  "delivery.accounts.label.extraDeliveries": "Invii extra",
  "delivery.accounts.label.plan": "Piano",
  "delivery.accounts.label.remainingDeliveries": "Invii residui",
  "delivery.accounts.label.renewalDate": "Prossimo rinnovo",
  "delivery.accounts.label.type": "Tipologia",
  "delivery.accounts.label.waiting_payment": "In attesa di pagamento",
  "delivery.accounts.list.title": "Utenze Email Delivery gestibili",
  "delivery.accounts.listDesc":
    "Le utenze vengono create contestualmente alla sottoscrizione di un piano per l'invio di email. Ogni utenza è caratterizzata da nome utente e password, tipologia e limiti di invii. Ad ogni utenza sono associati uno o più domini autorizzati all’invio. La reputazione del servizio è legata all’utenza.",
  "delivery.accounts.listTitle": "Utenze",
  "delivery.accounts.serviceManagement.changePlan.desc": "Cambia il piano dell'utenza",
  "delivery.accounts.serviceManagement.changePlan.info":
    "È possibile cambiare il piano attivo sull'utenza scegliendo tra le tipologie Free, Abbonamento mensile, Pacchetto pregapato. Il nuovo piano sarà attivo dopo che verrà effettuato il pagamento. Fino a quel momento sarà possibile continuare ad utilizzare il piano attuale. Quando il nuovo piano sarà attivo, i messaggi residui non ancora inviati del piano attuale verranno persi.",
  "delivery.accounts.serviceManagement.changePlan.title": "Cambia piano",
  "delivery.accounts.serviceManagement.delete.desc": "Elimina l'utenza per terminare il servizio.",
  "delivery.accounts.serviceManagement.delete.info":
    "Per terminare il servizio devi eliminare l’utenza. I domini associati all’utenza non verranno eliminati. Gli indirizzi in lista di soppressione collegati alla presente utenza verranno eliminati: si consiglia di esportare la lista di soppressione prima di eliminare l’utenza.",
  "delivery.accounts.serviceManagement.delete.title": "Termina il servizio",
  "delivery.accounts.serviceManagement.restore.desc": "Ripristina l'utente prima della sua cancellazione definitiva",
  "delivery.accounts.serviceManagement.restore.info":
    "É possibile riattivare l’abbonamento mensile prima della cancellazione.<br/>Una volta che l’utenza sarà stata eliminata non sarà più possibile ripristinarla.",
  "delivery.accounts.serviceManagement.restore.title": "Ripristina il servizio",
  "delivery.accounts.show.detailInfo.type.promotional": "Promozionale",
  "delivery.accounts.show.detailInfo.type.transactional": "Transazionale",
  "delivery.accounts.show.pageLabel.username": "Username",
  "delivery.accounts.show.warning.noDomains.msg":
    "Nessun dominio associato. Finchè non associ un dominio l'utenza non può inviare.",
  "delivery.accounts.update.stepPlanModification.change": "Cosa cambierà",
  "delivery.accounts.update.stepPlanModification.desc": "Seleziona un piano e il numero di messaggi.",
  "delivery.accounts.update.stepPlanModification.desc.monthly":
    "Se modifichi il numero di messaggi compresi nel piano perderai quelli residui del mese in corso.",
  "delivery.accounts.update.stepPlanModification.desc.prepaid": "Di seguito è riportato il riepilogo dell'ordine.",
  "delivery.accounts.update.stepPlanModification.expiration": "Scadenza: ",
  "delivery.accounts.update.stepPlanModification.plan.title": "Nuovo piano",
  "delivery.accounts.update.stepPlanModification.title": "Sottoscrivi un diverso piano per l’utenza",
  "delivery.accounts.update.stepPlanModification.title.monthly": "Modifica invii mensili",
  "delivery.accounts.update.stepPlanModification.title.prepaid": "Acquista un nuovo pacchetto",
  "delivery.accounts.update.stepRecap.desc": "Di seguito è riportato il riepilogo dell'ordine.",
  "delivery.accounts.update.stepRecap.modal.info.free":
    "Il piano Free è stato attivato correttamente su questa utenza.",
  "delivery.accounts.update.stepRecap.modal.info.monthly":
    "Riceverai un'email con il riepilogo dell'ordine effettuato e un link per effettuare il pagamanto. Il prodotto acquistato sarà attivo non appena avremo registrato il pagamento.<br/><br/>Nel frattempo puoi continuare ad utilizzare il piano attuale.",
  "delivery.accounts.update.stepRecap.modal.info.prepaid":
    "Riceverai un'email con il riepilogo dell'ordine effettuato e un link per effettuare il pagamento. Il prodotto acquistato sarà disponibile entro 24 ore dalla ricezione del pagamento.",
  "delivery.accounts.update.stepRecap.modal.title": "Ordine inserito",
  "delivery.accounts.update.stepRecap.title": "Riepilogo e pagamento",
  "delivery.accounts.volumeManagement.desc": "Imposta il numero di messaggi disponibili per l'account.",
  "delivery.accounts.volumeManagement.title": "Messaggi disponibili",
  "delivery.accounts.volumes.monthly.10000": "10.000",
  "delivery.accounts.volumes.monthly.100000": "100.000",
  "delivery.accounts.volumes.monthly.250000": "250.000",
  "delivery.accounts.volumes.monthly.30000": "30.000",
  "delivery.accounts.volumes.monthly.5000": "5.000",
  "delivery.accounts.volumes.monthly.60000": "60.000",
  "delivery.accounts.volumes.more": "Più di 250.000",
  "delivery.dashboardActivities.accepted": "Presi in carico",
  "delivery.dashboardActivities.bounces": "Bounce",
  "delivery.dashboardActivities.delivered": "Consegnati",
  "delivery.dashboardActivities.enqueued": "In coda",
  "delivery.dashboardActivities.suppressed": "Soppressi",
  "delivery.dashboardActivities.unavailable": "Momentaneamente non disponibili",
  "delivery.domains.accounts.connectedAccounts.desc":
    "Elenco delle utenze alle quali è associato il dominio e per le quali è autorizzato ad inviare. ",
  "delivery.domains.accounts.connectedAccounts.title": "Associazione dominio-utenze",
  "delivery.domains.accounts.noAssociatedAccounts.desc": "Nessuna utenza associata",
  "delivery.domains.accounts.warningMessage": "Per associare il dominio ad una nuova utenza vai nella sezione Utenze.",
  "delivery.domains.add.modal.message":
    "Il dominio è stato creato, per poterlo utilizzare è necessario effattuare la <b>procedura di verifica</b>. <br/>Una volta effettuata la verifica, i nostri sistemi procederanno in automatico con la <b>fase di approvazione</b>. <br/><b>RICORDA</b>: per poter inviare con il dominio devi associarlo ad almeno un'utenza.",
  "delivery.domains.add.step1.desc":
    "Crea un nuovo dominio da associare ad un’utenza per inviare email transazionali e promozionali.",
  "delivery.domains.add.step1.name.msg": "Indica il nome del nuovo dominio:",
  "delivery.domains.add.step1.title": "Aggiungi un dominio per l'invio",
  "delivery.domains.approval.approveAndActivate.warningMsg":
    "ATTENZIONE: Una volta saltata l'approvazione il dominio potrà inviare anche senza una corretta configurazione dei DNS",
  "delivery.domains.approval.info.desc":
    "Consulta l'esito della procedura di approvazione che viene eseguita in automatico.",
  "delivery.domains.approval.info.message.approved": "Dominio approvato",
  "delivery.domains.approval.info.message.needApproval":
    "Il dominio è in attesa di essere approvato dai nostri sistemi ad inviare messaggi. Riceverai un'email con il responso.",
  "delivery.domains.approval.info.message.notApproved":
    "Il dominio non ha superato i controlli dei nostri sistemi e non è stato approvato per l'invio per il seguente motivo:",
  "delivery.domains.approval.info.message.pending": "Approvazione in corso",
  "delivery.domains.approval.info.title": "Approvazione per l'invio di email",
  "delivery.domains.dns.fail": "",
  "delivery.domains.dns.success": "",
  "delivery.domains.list.desc":
    "I Domini vengono aggiunti nel sistema per poter essere autorizzati ad inviare email. Essi devono essere associati ad almeno un'Utenza. Ogni dominio ha una sua firma DKIM.",
  "delivery.domains.list.title": "Domini",
  "delivery.domains.show.label.active": "Attivo",
  "delivery.domains.show.label.inactive": "Disattivo",
  "delivery.domains.show.warning.noAccounts.msg": "Il dominio non è associato a nessuna utenza e non può inviare.",
  "delivery.domains.status.approved": "Attivo",
  "delivery.domains.status.approved_dns": "DNS mal configurati",
  "delivery.domains.status.disabled_by_admin": "Disattivato da admin",
  "delivery.domains.status.disabled_by_customer": "Disattivato da cliente",
  "delivery.domains.status.need_approval": "In attesa di approvazione",
  "delivery.domains.status.not_verified": "In attesa di verifica",
  "delivery.domains.status.pending_approval": "In approvazione",
  "delivery.domains.verification.notVerified": "Non verificato",
  "delivery.domains.verification.send": "Invia",
  "delivery.domains.verification.send.error": "Errore nell'invio dell'email",
  "delivery.domains.verification.send.success": "Email inviata correttamente a {email}",
  "delivery.domains.verification.share_email": "Indirizzo a cui vuoi mandare i parametri",
  "delivery.domains.verification.share_email_desc":
    "Invia i dettagli per la configurazione del dominio a un indirizzo email",
  "delivery.domains.verification.share_email_error": "Non è un indirizzo email valido",
  "delivery.domains.verification.share_params_download": "Oppure scaricali in formato .csv",
  "delivery.domains.verification.spf_dkim.desc":
    "Inserisci questi parametri di verifica nel pannello di gestione DNS del tuo dominio e poi clicca il pulsante in fondo a questa pagina.",
  "delivery.domains.verification.spf_dkim.dkim.label": "Verifica DKIM",
  "delivery.domains.verification.spf_dkim.dkim.warningMessage":
    "Per garantire la sicurezza del dominio richiediamo la configurazione di due chiavi DKIM sottoforma di record CNAME",
  "delivery.domains.verification.spf_dkim.dmarc.label": "Verifica DMARC",
  "delivery.domains.verification.spf_dkim.dmarc.warningMessage":
    "È sufficiente che sia impostato un recordo DMARC valido sul dominio. Quello riportato di seguito è un esempio.",
  "delivery.domains.verification.spf_dkim.shareRecords": "Condividi parametri",
  "delivery.domains.verification.spf_dkim.spf.label": "Verifica SPF",
  "delivery.domains.verification.spf_dkim.spf.warningMessage":
    "È sufficiente che sia presente il nostro parametro <em>include</em> nel record SPF del tuo dominio. Quello riportato di seguito è un esempio.",
  "delivery.domains.verification.spf_dkim.title": "Parametri verifica SPF e DKIM",
  "delivery.domains.verification.verified": "Verificato",
  "delivery.intro.betaBanner.description":
    "Nella versione Beta, attualmente disponibile, è possibile sottoscrivere solamente il piano Free Trial con 5000 invii mensili.",
  "delivery.intro.betaBanner.title": "IL SERVIZIO È DISPONIBILE IN VERSIONE BETA GRATUITA",
  "delivery.intro.description":
    "Email Delivery è il servizio dedicato all'invio di grandi volumi di messaggi email tramite il protocollo SMTP.<br />Invia email transazionali e promozionali senza abbandonare il tuo applicativo preferito per l'invio. Email Delivery è il nostro motore SMTP che assicura la migliore deliverability possibile.",
  "delivery.intro.title": "Email Delivery",
  "delivery.label.account": "Utenza",
  "delivery.maintenance.description": "Il servizio è attualmente in manutenzione. Riprova più tardi.",
  "delivery.maintenance.title": "Il servizio Delivery Beta non è al momento disponibile",
  "delivery.managedDomains.list.title": "Domini Email Delivery gestibili",
  "delivery.manager.alert":
    "Una volta completata l'operazione, il manager potrà visualizzare, modificare ed eliminare l'account selezionato e <b>tutti i domini</b> ad esso associati.",
  "delivery.manager.alertDomains":
    "Una volta completata l'operazione, il manager potrà visualizzare, modificare ed eliminare il dominio selezionato e <b>tutti gli account</b> ad esso associati.",
  "delivery.manager.alertGeneric":
    "Una volta completata l'operazione, il manager potrà visualizzare, modificare ed eliminare tutte queste risorse.",
  "delivery.manager.confirmAccountAssign": "Vuoi assegnare l'account {accountId} a questo manager?",
  "delivery.manager.confirmDomainAssign": "Vuoi assegnare il dominio {accountId} a questo manager?",
  "delivery.manager.loadingLinkedResources": "Caricando risorse coinvolte",
  "delivery.manager.noFreeResources": "Nessuna utenza o dominio assegnabile al manager disponibile.",
  "delivery.manager.pick.account": "Scegli l'account che vuoi assegnare a questo manager.",
  "delivery.manager.pick.body": "Per iniziare, seleziona il tipo di risorsa che vuole assegnare al manager.",
  "delivery.manager.pick.button.account": "Assegna Account",
  "delivery.manager.pick.button.domain": "Assegna Dominio",
  "delivery.manager.pick.domain": "Scegli il dominio che vuoi assegnare a questo manager.",
  "delivery.manager.pick.title": "Vuoi assegnare un'utenza o un dominio?",
  "delivery.modal.extradeliveryOrder.cancel.content":
    "Confermi di voler annullare l'ordine inserito relativo all'acquisto di pacchetti di messaggi email extra?",
  "delivery.modal.extradeliveryOrder.cancel.title": "Vuoi annullare l'ordine?",
  "delivery.modal.planModification.cancel.content":
    "Se annulli la modifica richiesta, il piano attuale rimarrà invariato.",
  "delivery.modal.planModification.cancel.title": "Vuoi annullare la richiesta di modifica del piano?",
  "delivery.plan.free": "Free",
  "delivery.plan.monthly": "Mensile",
  "delivery.plan.prepaid": "Prepagato",
  "delivery.suppressionList.add.alert.success": "Email aggiunta con successo alla lista",
  "delivery.suppressionList.add.desc":
    "Escludi un indirizzo dai destinatari delle email che invii aggiungendolo alla lista di soppressione. Indica il motivo dell'esclusione e per quali utenze deve essere attivo.",
  "delivery.suppressionList.add.email.label": "Indirizzo email",
  "delivery.suppressionList.add.reason.bounce.label": "Bounce",
  "delivery.suppressionList.add.reason.complain.label": "Reclamo",
  "delivery.suppressionList.add.reason.title": "Seleziona il motivo dell'esclusione:",
  "delivery.suppressionList.add.restrictionRules.allAccountsToggle.label": "Blocca le email inviate da tutte le utenze",
  "delivery.suppressionList.add.restrictionRules.singleAccountToggle.label":
    "Blocca le email inviate da specifiche utenze",
  "delivery.suppressionList.add.restrictionRules.title": "Regole di restrizione invio email",
  "delivery.suppressionList.add.title": "Aggiungi un indirizzo email alla lista di soppressione",
  "delivery.suppressionList.details.desc":
    "Consulta e modifica le regole di restrizione impostate per l’indirizzo email.",
  "delivery.suppressionList.details.title": "Regole di restrizione",
  "delivery.suppressionList.list.all": "Tutte",
  "delivery.suppressionList.list.desc":
    "Gli indirizzi di posta elettronica che compongono la lista di soppressione sono tutti gli indirizzi che hanno generato un bounce o che hanno segnalato le comunicazioni ricevute come spam (reclami). Gli indirizzi che hanno generato un bounce vengono aggiunti automaticamente alla lista, i reclami devono invece essere inseriti manualmente.",
  "delivery.suppressionList.list.title": "Lista di soppressione",
  "delivery.tracemail.contentTableItemLabel.accountId": "ID utenza",
  "delivery.tracemail.contentTableItemLabel.country": "Paese",
  "delivery.tracemail.contentTableItemLabel.deliveryDate": "Data",
  "delivery.tracemail.contentTableItemLabel.messageId": "ID messaggio",
  "delivery.tracemail.contentTableItemLabel.mxHost": "Relay",
  "delivery.tracemail.contentTableItemLabel.pool": "Pool di invio",
  "delivery.tracemail.contentTableItemLabel.recipient": "Destinatario",
  "delivery.tracemail.contentTableItemLabel.relay": "Relay",
  "delivery.tracemail.contentTableItemLabel.response": "Risposta",
  "delivery.tracemail.contentTableItemLabel.sender": "Mittente",
  "delivery.tracemail.contentTableItemLabel.senderIp": "IP mittente",
  "delivery.tracemail.contentTableItemLabel.size": "Dimensione",
  "delivery.tracemail.contentTableItemLabel.smtpId": "SMTP ID",
  "delivery.tracemail.contentTableItemLabel.smtpResult": "Risposta",
  "delivery.tracemail.contentTableItemLabel.subject": "Oggetto",
  "delivery.tracemail.contentTableItemLabel.time": "Data",
  "delivery.tracemail.contentTableItemLabel.username": "Username",
  "delivery.tracemail.desc":
    "Tracemail consente di analizzare in tempo reale i log del traffico email in uscita. Esegui la ricerca compilando i campi sottostanti, partendo dall'utenza.",
  "delivery.tracemail.message": "Messaggio",
  "delivery.tracemail.result": "Messaggi inviati totali: ",
  "delivery.tracemail.result.all": "Tutti",
  "delivery.tracemail.result.bounced": "Respinti",
  "delivery.tracemail.result.delivered": "Consegnati",
  "delivery.tracemail.result.enqueued": "In coda",
  "delivery.tracemail.result.limits": "Limiti",
  "delivery.tracemail.result.login": "Autenticazione",
  "delivery.tracemail.result.status.bounced": "Respinto",
  "delivery.tracemail.result.status.delivered": "Consegnato",
  "delivery.tracemail.result.status.enqueued": "In coda",
  "delivery.tracemail.result.status.sent": "Inviato",
  "delivery.tracemail.result.status.suppressed": "Soppresso",
  "delivery.tracemail.result.suppressed": "Soppressi",
  "delivery.volume.monthly": "{amount} / mese",
  "delivery.waitlist.success": "Richiesta inviata con successo",
  "description.text.delegate.recoveryPassword":
    "Verrà inviata una email a <code>{emailDelegate}</code> con le istruzioni per il recupero della password.",
  "description.text.delegate.recoveryPassword.email":
    "È stata inviata una email a <code>{emailDelegate}</code> con le istruzioni per il recupero della password.",
  "description.text.disabledDKIM":
    "La firma DKIM non è attiva su questo dominio, per attivarla clicca qui e segui le istruzioni visualizzate",
  "description.text.enabledDKIM": "La firma DKIM è attivata correttamente",
  "detail.status.disabled": "Disattivo",
  "detail.status.enabled": "Attivo",
  "detail.status.updating": "Aggiornamento",
  "detailInfo.data.currentSession": "Corrente",
  "detailInfo.data.messages.viewDate.noLimits": "Senza limiti temporali",
  "detailInfo.data.never": "Mai",
  "detailInfo.data.no": "No",
  "detailInfo.data.noExpiration": "Senza scadenza",
  "detailInfo.data.paymentType.bank": "Bonifico bancario",
  "detailInfo.data.paymentType.paypal": "PayPal o carta di credito",
  "detailInfo.data.paymentType.paypalAuto": "PayPal con addebito automatico",
  "detailInfo.data.paymentType.stripe": "Carta di credito con addebito automatico",
  "detailInfo.data.user.company": "Azienda",
  "detailInfo.data.user.privato": "Utente privato",
  "detailInfo.data.volume.monthly": "{amount} / mese",
  "detailInfo.data.volume.prepaid": "{amount}",
  "detailInfo.data.year": "anno",
  "detailInfo.data.years": "anni",
  "detailInfo.data.yes": "Si",
  "detailInfo.label.DKIM.domain": "Dominio DKIM",
  "detailInfo.label.DKIM.selector": "Selettore DKIM",
  "detailInfo.label.DNS": "DNS",
  "detailInfo.label.DSN": "DNS",
  "detailInfo.label.account": "Account",
  "detailInfo.label.account25": "Account 25GB",
  "detailInfo.label.account8": "Account 8GB",
  "detailInfo.label.action": "Azione",
  "detailInfo.label.activeOnNewMboxes": "Attiva su nuovi account",
  "detailInfo.label.address": "Indirizzo",
  "detailInfo.label.analisysTime": "Tempo di analisi",
  "detailInfo.label.archive": "Archivi",
  "detailInfo.label.archive.delegates": "Delegati",
  "detailInfo.label.archive.import": "Data importazione",
  "detailInfo.label.archive.messages": "Messaggi archiviati",
  "detailInfo.label.archive.quota": "Spazio occupato",
  "detailInfo.label.archive.start": "Inizio archiviazione",
  "detailInfo.label.availableMessages": "Messaggi disponibili",
  "detailInfo.label.billingCycle": "Frequenza pagamento",
  "detailInfo.label.billingEmail": "Le fatture verranno inviate a",
  "detailInfo.label.category": "Categoria",
  "detailInfo.label.city": "Città",
  "detailInfo.label.client": "Client",
  "detailInfo.label.code": "Codice",
  "detailInfo.label.company": "Azienda",
  "detailInfo.label.connectedDomains": "Domini associati",
  "detailInfo.label.country": "Paese",
  "detailInfo.label.created": "Creato il",
  "detailInfo.label.customerCode": "Codice Cliente",
  "detailInfo.label.date": "Data",
  "detailInfo.label.defaultQuota": "Dimensione default",
  "detailInfo.label.delay": "Ritardo",
  "detailInfo.label.deliveryAccounts": "Account di invio",
  "detailInfo.label.deliveryDomains": "Domini di invio",
  "detailInfo.label.deliverytime": "Tempo di consegna",
  "detailInfo.label.detail": "Dettaglio",
  "detailInfo.label.domains": "Domini",
  "detailInfo.label.email": "Email",
  "detailInfo.label.emailAccounts25gb": "Account 25GB",
  "detailInfo.label.emailAccounts50gb": "Account 50GB",
  "detailInfo.label.emailAccounts8gb": "Account 8GB",
  "detailInfo.label.error.authentication": "Err. autenticazione",
  "detailInfo.label.expiration": "Scadenza",
  "detailInfo.label.expirationDate": "Scadenza",
  "detailInfo.label.file": "File",
  "detailInfo.label.filter": "Esito",
  "detailInfo.label.filter.detail": "Dettagli filtro",
  "detailInfo.label.firstName": "Nome",
  "detailInfo.label.fiscalcode": "Codice Fiscale",
  "detailInfo.label.fiscalcode2": "Codice Fiscale [se diverso da P.IVA]",
  "detailInfo.label.from": "Mittente",
  "detailInfo.label.lastAccess": "Ultimo accesso",
  "detailInfo.label.lastName": "Cognome",
  "detailInfo.label.localIP": "IP Qboxmail",
  "detailInfo.label.login.date": "Data login",
  "detailInfo.label.login.error": "Errore login",
  "detailInfo.label.logout.date": "Data logout",
  "detailInfo.label.manager": "Manager",
  "detailInfo.label.message": "Messaggio",
  "detailInfo.label.max.accounts25": "Limite max account 25GB",
  "detailInfo.label.max.accounts8": "Limite max account 8GB",
  "detailInfo.label.max.accountsSize": "Limite max dimensione account",
  "detailInfo.label.max.archive": "Limite max archivi",
  "detailInfo.label.max.domains": "Limite max domini",
  "detailInfo.label.messageID": "ID messaggio",
  "detailInfo.label.messages.rest": "Reset contatore",
  "detailInfo.label.messages.sent": "Messaggi inviati (24h)",
  "detailInfo.label.messages.viewDate": "Visualizzazione contenuti",
  "detailInfo.label.migration.first_execution": "Prima esecuzione",
  "detailInfo.label.migration.second_execution": "Seconda esecuzione",
  "detailInfo.label.msg.deleted": "Messaggi cancellati",
  "detailInfo.label.msg.expunged": "Messaggi eliminati",
  "detailInfo.label.msg.trashed": "Messaggi cestinati",
  "detailInfo.label.name": "Nome",
  "detailInfo.label.order.code": "Codice ordine",
  "detailInfo.label.order.minimunAccount": "Account aggiunti per ordine minimo",
  "detailInfo.label.order.status": "Stato dell'ordine",
  "detailInfo.label.permissions": "Autorizzazioni",
  "detailInfo.label.phonenumber": "Telefono",
  "detailInfo.label.plan": "Piano",
  "detailInfo.label.planVolumes": "Invii inclusi nel piano",
  "detailInfo.label.port": "Porta",
  "detailInfo.label.postcode": "CAP",
  "detailInfo.label.postmasterAccount": "Account postmaster",
  "detailInfo.label.private": "Privato",
  "detailInfo.label.protocol": "Protocollo",
  "detailInfo.label.quote": "Quota account",
  "detailInfo.label.reason": "Ragione",
  "detailInfo.label.recipient.number": "Tot. destinatari",
  "detailInfo.label.reject.code": "Codice errore",
  "detailInfo.label.reject.message": "Errore",
  "detailInfo.label.relay": "Relay",
  "detailInfo.label.remainingMessages": "Messaggi rimanenti",
  "detailInfo.label.remoteIP": "IP utente",
  "detailInfo.label.remoteServerHost": "Remote server host",
  "detailInfo.label.reputation": "Reputazione",
  "detailInfo.label.reseller": "Rivenditore",
  "detailInfo.label.response": "Risposta",
  "detailInfo.label.search.results": "Risultati ricerca",
  "detailInfo.label.selectedMboxes": "Account email selezionati",
  "detailInfo.label.server": "Hosting Server",
  "detailInfo.label.serverDelivery": "Server",
  "detailInfo.label.session": "Sessione",
  "detailInfo.label.size": "Dimensione",
  "detailInfo.label.smtpID": "SMTP ID",
  "detailInfo.label.spam": "Analisi antispam",
  "detailInfo.label.state": "Provincia",
  "detailInfo.label.storage": "Archiviazione",
  "detailInfo.label.storageOnNew": "Nuovi",
  "detailInfo.label.subject": "Oggetto",
  "detailInfo.label.suppressionReason": "Motivo di soppressione",
  "detailInfo.label.to": "Destinatario",
  "detailInfo.label.totalPrice": "Prezzo totale",
  "detailInfo.label.traffic.in": "Traffico in entrata",
  "detailInfo.label.traffic.out": "Traffico in uscita",
  "detailInfo.label.type": "Tipo",
  "detailInfo.label.user": "Account",
  "detailInfo.label.user.geoArea": "Area geografica",
  "detailInfo.label.user.kind": "Tipologia cliente",
  "detailInfo.label.user.reseller": "Cliente rivenditore",
  "detailInfo.label.user.whmcs.invoiceId": "WHMCS first Invoice ID",
  "detailInfo.label.user.whmcs.orderId": "WHMCS Order id",
  "detailInfo.label.value": "Valore",
  "detailInfo.label.vat": "Partita Iva",
  "detailInfo.lable.billing.email": "Email per invio fatture",
  "detailInfo.lable.paymentType": "Metodo di pagamento",
  "domainAlert.goToDocs": "Vai alla documentazione",
  "domainAlert.goToDocsMsg": "Non conosci i parametri MX?",
  "domainAlias.add.desc":
    "Il nuovo dominio alias erediterà tutti gli email account, email alias e forward del dominio reale a esso collegato.",
  "domainAlias.add.title": "Nuovo dominio alias",
  "domains.add.desc.step1":
    "Scegli il piano e le relative funzionalità con cui vuoi attivare il nuovo dominio e gli email account ad esso appartenenti.",
  "domains.add.desc.step2":
    "Inserisci le informazioni di contatto del dominio, la lingua e la time zone predefinite. Con il dominio verà creato automaticamente anche un postmaster, imposta una password per questo account.",
  "domains.add.desc.step3":
    "Imposta il numero di email account e archivi attivabili per il dominio e la loro dimensione.",
  "domains.add.desc.step4":
    "Imposta i servizi disponibili per gli account del dominio. <b>I servizi variano in base al piano selezionato</b>.",
  "domains.add.desc.step5": "Imposta le policy di sicurezza predefinite per il dominio e i suoi account.",
  "domains.add.desc.step6": "Imposta il livello di sensibilità del filtro antispam per gli account del dominio.",
  "domains.add.title.step1": "Piano dominio",
  "domains.add.title.step2": "Info dominio",
  "domains.add.title.step3": "Limiti dominio",
  "domains.add.title.step4": "Servizi dominio",
  "domains.add.title.step5": "Sicurezza dominio",
  "domains.add.title.step6": "Opzioni dominio",
  "domains.list.header.dsc": "I domini racchiudono tutti gli email account e gli email alias a essi appartenenti.",
  "domains.list.header.title": "Domini",
  "domains.list.table.label.code": "Codice",
  "domains.list.table.label.customer": "Customer",
  "domains.list.table.label.domain": "Domini",
  "domains.list.table.label.domainsAlias": "Domini alias",
  "domains.list.table.label.emailAccounts": "Email account",
  "domains.list.table.label.emailsAlias": "Email alias",
  "domains.list.table.label.status": "Status",
  "domains.settings.title": "Impostazioni dominio",
  "domains.show.desc.aliasDomains":
    "I domini alias sono domini collegati a domini reali che ereditano tutti i loro gli account: email account, email alias e forward.",
  "domains.show.desc.aliasEmailAccounts":
    "Gli email alias sono indirizzi email che inoltrano i messaggi ricevuti a uno o più indirizzi indicati come destinatari dell’alias.",
  "domains.show.desc.emailAccounts":
    "Gli email account sono indirizzi email i cui messaggi, inviati e ricevuti, sono accessibili via POP / IMAP / SMTP e Webmail.",
  "dropzone.invalidMIME": "Tipo di file non supportato",
  "emailAccountAlias.add.desc":
    "Il nuovo email alias inoltrerà tutti i messaggi ricevuti a tutti gli account indicati come destinatari.",
  "emailAccountAlias.add.title": "Nuovo email alias",
  "emailAccounts.add.desc.step1":
    "Inserisci il nome, le informazioni di contatto e la password dell'email account. Una volta creato <b>non è possibile rinominare un email account</b>.",
  "emailAccounts.add.desc.step2":
    "Imposta la dimensione dell'email account e i servizi disponibili. <b>Dimensione e servizi variano in base al piano e alle impostazioni del dominio</b>.",
  "emailAccounts.add.desc.step3":
    "Imposta le policy relative alla gestione delle password e agli accessi per l'email account.",
  "emailAccounts.add.desc.step4": "Imposta delle opzioni aggiuntive per l'email account.",
  "emailAccounts.add.title.step1": "Nuovo account",
  "emailAccounts.add.title.step2": "Servizi account",
  "emailAccounts.add.title.step3": "Sicurezza account",
  "emailAccounts.add.title.step4": "Opzioni account",
  "errorMsg.accept": "Devi accettare per effettuare l'ordine",
  "errorMsg.click.toVerify": "Premi il bottone per validare",
  "errorMsg.delegate.account": "Il delegato deve avere almeno un account email assegnato",
  "errorMsg.length.passowrd": "Password di almeno 8 caratteri alfanumerici",
  "errorMsg.missing.field": "Campo mancante",
  "errorMsg.notAvailable.domains": "Non hai domini disponibili",
  "errorMsg.notMarch.passowrd": "Password non corrispondenti",
  "errorMsg.notValid.URL": "URL non valido",
  "errorMsg.notValid.account.description": "Descrizione utenza invalida",
  "errorMsg.notValid.domain": "Dominio non valido",
  "errorMsg.notValid.emailAddress": "Indirizzo email non valido",
  "errorMsg.notValid.ip": "Indirizzo IP non valido",
  "errorMsg.notValid.loginCredentials": "Nome utente o password non validi",
  "errorMsg.notValid.number": "Deve essere un numero",
  "errorMsg.notValid.recipientCode": "Deve essere un codice alfanumerico di 7 cifre o un indirizzo PEC valido",
  "errorMsg.planRequired": "Specifica il piano per il nuovo dominio!",
  "errorMsg.required": "Obbligatorio",
  "errorMsg.required.customization.field":
    "Almeno un campo tra azienda, link supporto clienti e logo deve essere presente",
  "errorMsg.select.account": "Seleziona almeno un email account",
  "errorMsg.select.customer": "Seleziona un utente",
  "errorMsg.select.deliveryAccount": "Seleziona almeno un'utenza",
  "errorMsg.select.domain": "Seleziona almeno un dominio",
  "errorMsg.vaultFoldersError": "C'è stato un errore nel ricevere la lista delle cartelle. Contatta il supporto.",
  "errors.invalid_email": "Non è un indirizzo email valido",
  "errors.not_empty": "Non può essere vuoto",
  "errorsMsg.required.customization.custom_label": "E' obbligatoria per utilizzare il link personalizzato",
  "etlive.legend.error": "Errore",
  "etlive.legend.success": "Successo",
  "etlive.legend.title": "Legenda",
  "etlive.legend.warn": "Avviso",
  "etlive.list.header.dsc":
    "Tracemail consente di analizzare in tempo reale i log di accesso ai servizi e del traffico email in ingresso e in uscita.",
  "etlive.list.header.title": "Tracemail",
  "etlive.list.searchMsg.notFoundLog": "Nessun log trovato",
  "etlive.list.searchMsg.selectDomain": "Seleziona il dominio di cui vuoi vedere i log",
  "etlive.list.searchMsg.selectLog": "Seleziona il tipo di log che vuoi vedere",
  "etlive.log.accordion.attachments": "Allegati",
  "etlive.log.accordion.deliveries": "Consegne",
  "etlive.log.accordion.notification": "Notifiche",
  "etlive.log.accordion.notification.deliveries": "Notifiche di consegna",
  "etlive.log.export": "Rapporto PDF",
  "etlive.log.exportPDF": "PDF",
  "etlive.log.exporting": "Esportando",
  "etlive.log.exportingError": "C'è stato un problema nell'esportazione come PDF. Contattaci.",
  "etlive.log.locateMessage": "Localizza messaggio",
  "etlive.log.locateMessageLoading": "Cercando...",
  "etlive.log.locateMessageShort": "Localizza",
  "etlive.log.locatingError": "C'è stato un problema nella ricerca del messaggio. Contattaci.",
  "etlive.log.locatingMessage":
    "Il messaggio consegnato a <b>{recipient}</b> il <b>{delivered_at}</b> <br/> si trova in:",
  "etlive.log.locatingMessageNotFound":
    "Il messaggio consegnato a <b>{recipient}</b> il <b>{delivered_at}</b> <br/> <b>non è più presente</b> nella casella email. <br/> Potrebbe essere stato cancellato o scaricato via protocollo POP.",
  "etlive.log.title.accesss": "Accesso",
  "etlive.log.title.email.not.received": "Messaggio respinto",
  "etlive.log.title.email.not.sent": "Messaggio non inviato",
  "etlive.log.title.email.received": "Messaggio ricevuto",
  "etlive.log.title.email.sent": "Messaggio inviato",
  "feature.antimalware": "Antimalware Premium",
  "feature.antivirus": "Antivirus e Antispam",
  "feature.basic": "Funzionalità piano Basic",
  "feature.exchange": "Microsoft® Exchange ActiveSync",
  "feature.mailServices": "POP, IMAP, SMTP",
  "feature.mailboxSize": "Caselle fino a 25 GB",
  "feature.mailboxSize100": "Caselle fino a 100 GB",
  "feature.mailboxSize50": "Caselle fino a 50 GB",
  "feature.sharedCalendars": "Calendario e rubrica condivisi",
  "feature.webmail": "Webmail",
  "folderMapper.label.accounts": "Account",
  "folderMapper.label.all.accounts": "Tutti gli account",
  "folderMapper.label.all.folders": "Tutte le cartelle",
  "folderMapper.label.folders": "Cartelle",
  "folderMapper.label.full": "Tutto",
  "folderMapper.label.ignore": "Ignora",
  "folderMapper.label.in": "Ricevuti",
  "folderMapper.label.out": "Inviati",
  "folderMapper.label.subject": "Oggetto",
  "generals.requested.desc":
    "È stato aperto un ticket al Supporto Clienti per richiedere la modifica del limite di invio giornaliero per l’account. <br/> <br/> A breve riceverai un’email con il link al ticket dove dovrai indicare il limite che vuoi impostare.",
  "helpT.account.over8GB": "Gli email account sopra gli 8GB hanno un costo maggiore.",
  "helpT.add.emailAlias.destinations":
    "Assegna una destinazione alle email alias che stai creando e aggiungila alla lista. <code>Puoi assegnare fino a 20 destinazioni per singolo email alias</code>.",
  "helpT.addArchive.step1":
    "Sono selezionabili solo i domini che non hanno l'archivio già attivo e hanno superato la verifica della proprietà.",
  "helpT.addDomain.domainName.step2":
    "Il nome del dominio non deve contenere <code>www.</code>, inserisci solo il nome da visualizzare dopo <code>@</code>.",
  "helpT.addDomain.postmasterPassword.step2":
    "Inserisci un password per l'account <code>postmaster@DOMINIO</code>. Questo utente può gestire tutti gli account del dominio.",
  "helpT.addEmailAccounts.emailAccountsName.step1":
    "Se non è un email account personale inserisci una descrizione dell'account nel campo <code>Nome utente</code>.",
  "helpT.order.company.noVat":
    "Se la tua azienda è in possesso di Numero di Registrazione Impresa (Company Registration Number) ma non di una Partita IVA inserisci <code>NOVATID</code>.<br/>Dovrai poi comunicarci questo identificativo per verifica.",
  "helpT.order.company.referent": "Inserisci il nome del referente o del rappresentante legale dell'azienda.",
  "helpT.order.domain.add":
    "Il nome del dominio non deve contenere <code>www.</code>, inserisci solo il nome da visualizzare dopo <code>@</code>.<br/>Una volta completato l'ordine potrai aggiungerlo alla lista dei tuoi domini.",
  "helpT.order.domain.exist":
    "Non è possibile modificare il nome del dominio in quanto già presente nella tua lista domini.<br/>Una volta completato l'ordine potrai continuare a gestirlo.",
  "helpT.order.plan.basic.desc": "Per i professionisti o le aziende che vogliono un servizio conveniente e di qualità.",
  "helpT.order.plan.basic.title": "Basic",
  "helpT.order.plan.enterprise.desc":
    "Per le organizzazioni che necessitano di strumenti di comunicazione avanzata per i proprio collaboratori e di una sicurezza elevata nell’utilizzo dei servizi.",
  "helpT.order.plan.enterprise.title": "Enterprise",
  "helpT.order.plan.professional.desc":
    "Per le aziende che hanno bisogno di coordinarsi e comunicare con tutti i propri collaboratori in modo semplice e intuitivo",
  "helpT.order.plan.professional.title": "Professional",
  "imports.add.desc":
    "Crea il file .CSV con le informazioni necessarie e importa domini, domini alias, email account e email alias.",
  "imports.add.title": "Nuova importazione",
  "imports.list.header.dsc":
    "Le Importazioni consentono di inserire nel pannello domini, domini alias, email account e account alias attraverso un file .CSV.",
  "imports.list.header.title": "Importazioni",
  "imports.resources.header.alias_domain": "Dominio Alias",
  "imports.resources.header.destinations": "Destinazioni",
  "imports.resources.header.firstname": "Nome",
  "imports.resources.header.forwards": "Inoltri",
  "imports.resources.header.lastname": "Cognome",
  "imports.resources.header.manager_code": "Codice manager",
  "imports.resources.header.password_type": "Formato password importata",
  "imports.resources.header.postmaster_password": "Formato password postmaster importata",
  "imports.resources.header.title": "Importazione",
  "imports.resources.passwordType.hash": "Hash",
  "imports.resources.passwordType.plain": "In chiaro",
  included: "inclusi",
  "infoMsg.DKIMInstruction": "Inserisci il seguente record TXT nella configurazione DNS del tuo dominio",
  "infoMsg.OTP.disabled": "L'utente non ha attivato l'OTP su questo account.",
  "infoMsg.account.updating": "Impostazione dell'account in aggiornamento",
  "infoMsg.advancedContactInfo":
    "Queste informazioni verranno visualizzate all'interno della Rubrica aziendale. L'anagrafica avanzata è disponibile <b>solo per i piani Professional ed Enterprise</b>. Aggiorna il piano del dominio per abilitare l'inserimento.",
  "infoMsg.annualSendingLimit":
    "Per modificare il limite di invio giornaliero è necessario richiederlo mediante apertura ticket al Supporto Clienti.",
  "infoMsg.apiUsage.disabled": "L'utilizzo delle API è disabilitato per questo account",
  "infoMsg.archiveAlready": "Archivio già attivo",
  "infoMsg.billing":
    "Le credenziale per accedere al pannello di gestione dei tuoi domini saranno in ogni caso indipendenti da quelle per accedere all'area di fatturazione.",
  "infoMsg.billing.system":
    "Le tue credenziali di accesso al sistema di fatturazione sono:<br/><br/>Username:<code>{userName}</code><br/>Password: <code>Password pannello di controllo</code><br/><br/>Usa queste credenziali per accedere al sistema di fatturazione attraverso il link che riceverai via email o scegli un altro indirizzo email e password per accedere.",
  "infoMsg.canInfluenceBilling": "Può influire sulla fatturazione",
  "infoMsg.catchAllDisabled": "Non puoi abilitare la catch all, contattaci per maggiori info",
  "infoMsg.catchAllDisabledAdmin": "Il cliente non può abilitare la catch all, modifica le impostazioni per attivarla",
  "infoMsg.code.newGeneration": "Generazione nuovo codice",
  "infoMsg.confirmed.emailAddress": "Indirizzo email confermato con successo",
  "infoMsg.delivery.pendingExtradeliveryOrder":
    "È stato inserito un ordine per l'acquisto di messaggi email extra. I messaggi saranno disponibili entro 24 ore dalla ricezione del pagamento.",
  "infoMsg.delivery.pendingUpdateOrder.modification":
    "E' stata richiesta una modifica del piano. La modifica verrà applicata entro 24 dalla ricezione del pagamento.",
  "infoMsg.delivery.pendingUpdateOrder.purchase":
    "E' stato inserito l'ordine per l'acquisto di un altro pacchetto di invii. I messaggi saranno disponibili entro 24 ore dalla ricezione del pagamento.",
  "infoMsg.delivery.selectAccountFirst": "Per prima cosa, seleziona l'utenza",
  "infoMsg.delivery.unhealthy.desc": "Verifica la tua configurazione per assicurarti che le email vengano consegnate.",
  "infoMsg.delivery.unhealthy.text": "La configurazione DNS per il dominio non è corretta.",
  "infoMsg.disabled.inTtrial": "Modifica non disponibile per utenti in trial",
  "infoMsg.disabledWhileWaitPaid": "Il limite di invio non può essere modificato durante il periodo di prova.",
  "infoMsg.domainUpdating": "Il dominio è in aggiornamento, sarà possibile modificarlo tra poco",
  "infoMsg.downgradeEmails": "Per rimuovere account dal dominio contatta il supporto clienti",
  "infoMsg.downgradePlan": "Per effettuare il downgrade del piano contatta il supporto clienti",
  "infoMsg.etliveUnavailable.msg": "Tracemail è momentaneamente non disponibile",
  "infoMsg.expertModeOnlyReseller": "Il csv avanzato è disponibile solo per i rivenditori",
  "infoMsg.invoice.monthly":
    "Completa l'ordine e potrai attivare in seguito tutte gli email account di cui hai bisogno.",
  "infoMsg.linkedToAccount": "Associato all'account {acc}",
  "infoMsg.linkedToDomain": "Associato al dominio: {dom}",
  "infoMsg.loading.accounts": "Caricamento email account",
  "infoMsg.loading.limits": "Caricamento limiti invio in corso...",
  "infoMsg.loadingMboxes": "Caricamento email account",
  "infoMsg.managerInvolvedDeliveryDomains":
    "Il manager avrà i permessi di gestione anche per i domini associati: <b>{involvedDomains}</b>",
  "infoMsg.manualLimits": "Imposta i limiti manualmente",
  "infoMsg.maxDomainQuota": "Non può essere superiore alla quota del dominio",
  "infoMsg.maxQuota":
    "L’applicazione di una dimensione massima diversa da quelle predefinite non comporta una riduzione di costo.",
  "infoMsg.noCustomizations.available.desc":
    "Tutti i tuoi domini con piano professional o enterprise hanno già una personalizzazione. Elimina una delle personalizzazioni presenti per crearne una nuova.",
  "infoMsg.noCustomizations.available.msg": "Non hai domini da personalizzare",
  "infoMsg.noDataAvailableYet.msg": "Nessun dato ancora disponibile",
  "infoMsg.noDomsSelected":
    "Il dominio non ha email account, è necessario almeno un account su cui attivare l'archivio",
  "infoMsg.noElements": "Nessun elemento",
  "infoMsg.noMoreLogs": "Non ci sono altri log",
  "infoMsg.noOrder": "Nessun ordine effettuato",
  "infoMsg.noRecords.desc": "La ricerca non ha prodotto risultati, riprova utilizzando criteri diversi.",
  "infoMsg.noRecords.msg": "Nessun elemento trovato",
  "infoMsg.noVat": "IVA esclusa",
  "infoMsg.not.achive.domain": "Non ci sono account con archivio attivo per questo dominio.",
  "infoMsg.notFoundURL.desc": "La pagina che stai cercando non è disponibile, non perdere la speranza!",
  "infoMsg.notFoundURL.msg": "La pagina che stai cercando non esiste",
  "infoMsg.order.annual":
    "Per completare la procedura è necessario ordinare almeno 5 email account distribuibili anche su più domini. Tutti i prezzi si intendono IVA esclusa.",
  "infoMsg.order.domain.notInfo": "Completa le informazioni per tutti i domini.",
  "infoMsg.order.minimum.annual":
    "Devi inserire <b>almeno 5 email account</b>, anche su domini diversi, per effetture l'ordine.",
  "infoMsg.order.minimum.annual.domain":
    "Devi inserire almeno <b>1 dominio</b> e <b>5 email account</b> per effetture l'ordine.",
  "infoMsg.order.minimum.monthly":
    "Ordine minimo 5 email account. Verranno <b>aggiunti {accountNumber} account</b> al tuo ordine che potrai attivare non appena completata la procedura.",
  "infoMsg.order.monthly":
    "Una volta completato l'ordine potrai attivare tutti i domini e gli email account di cui hai bisogno.",
  "infoMsg.otp.cantDisable": "Non puoi disattivare l'autenticazione a due fattori su questo account",
  "infoMsg.owCheckHTML.failed": "Verifica fallita. Controlla di aver seguito correttamente le istruzioni",
  "infoMsg.passwordReset.disabled": "Il reset della password è disabilito per questo account",
  "infoMsg.payOption": "Opzione a pagamento",
  "infoMsg.payOption.invoice": "Il salvataggio di questa impostazione avrà un impatto sulla tua prossima fattura",
  "infoMsg.planAlert.noBasic":
    "Queste funzionalità sono disponibili <b>solo per i piani Professional ed Enterprise</b>.",
  "infoMsg.planAlert.noProfessional": "Queste funzionalità sono disponibili <b>solo per il piano Enterprise</b>.",
  "infoMsg.priceVat": "Tutti i prezzi si intendono <b>IVA esclusa</b>.",
  "infoMsg.requestSent":
    "È stata inviata una richiesta il giorno {date} alle ore {time}. Sarà possibile inviare un’altra richiesta passate 24 ore.",
  "infoMsg.resetPwdForced": "L'utente dovrà aggiornare la sua password al prossimo login",
  "infoMsg.resetPwdForcedAll": "Gli utenti del dominio dovranno aggiornare la password al prossimo login",
  "infoMsg.sanityCheck.failed": "Qualcosa è andato storto, contattaci",
  "infoMsg.selectDomainFirst": "Per prima cosa seleziona un dominio",
  "infoMsg.token.copied": "Codice token copiato",
  "infoMsg.trial.customer": "Sei nel periodo di prova, non puoi attivare più di 5 domini e 25 email account",
  "infoMsg.trialAdvancedSettings": "Potrai modificare le impostazioni avanzate quando avrai completato un ordine",
  "infoMsg.unhealthy.desc":
    "Se hai già eseguito l'aggiornamento, ignora questo avviso. Scomparirà automaticamente entro 24 ore.",
  "infoMsg.unhealthy.text": "Dominio attivo. Aggiorna o verifica i record MX.",
  "infoMsg.unsaveChanged": "Salva le modifiche o verranno perse",
  "infoMsg.validation.domain.inPorgress": "Validazione domini in corso...",
  "infoMsg.verifingOwnershipCheck":
    "Stiamo verificando il record DNS. Potrebbero essere necessarie fino a 24 ore prima che la modifica al DNS del dominio sia operativa",
  "infoMsg.verify.emailAddress":
    "Verifica il tuo indirizzo email prima di accedere. (Cliccando il link nell'email che ti abbiamo mandato)",
  "infoMsg.webmail.signature.account.planAlert":
    "La gestione delle firme dal Pannello di controllo è disponibile <b>solo per i piani Professional ed Enterprise</b>.",
  "infoMsg.webmail.signature.domain.planAlert":
    "La gestione centralizzata delle firme è disponibile <b>solo per i piani Professional ed Enterprise</b>.",
  "input.error.empity": "Compila il campo",
  "input.error.notValid.domain": "Dominio non valido",
  "input.error.pwdMatch": "Password non corrispondente",
  "input.hint.account.size":
    "La dimensione massima attivabile per questo account è <code>{maxSize}</code>. Puoi modificare questo valore dalle Impostazioni del dominio",
  "input.hint.activeNow": "Ora attivi: <b>{resourcesCustomer}</b>",
  "input.hint.activeNowFull":
    "Ora attivi: <b>{total}</b> (<b>{gb8}</b> da 8GB, <b>{gb25}</b> da 25GB,  <b>{postmaster}</b> domini solo postmaster)",
  "input.hint.archive.retention":
    "La durata di archiviazione viene calcolata partendo dalla data di ricezione/invio di ogni singolo messaggio. I messaggi la cui cui data supera il periodo di conservazione scelto verranno automaticamente cancellati dall’archivio.",
  "input.hint.autoresponder": "Non può essere attivato quando <code>respingi messaggi</code> è attivo.",
  "input.hint.billing.annually":
    "Permette di attivare un numero fisso di caselle email che rimane invariato per un anno. [Non disponibile per i rivenditori]",
  "input.hint.billing.monthly":
    "Permette di avere la massima flessibilità nella gestione delle caselle email: potrai creare, modificare e eliminare le caselle in ogni momento. Il canone mensile sarà adeguato automaticamente. Ordine minimo 5 caselle.",
  "input.hint.customization.company":
    "Inserisci il nome dell'azienda che desideri visualizzare nel titolo della pagina",
  "input.hint.customization.customUrl1":
    "Puoi usare questo campo per aggiungere un link personalizzato che verrà visualizzato nella pagina di accesso della webmail.",
  "input.hint.customization.helpDeskUrl":
    "Inserisci il link al tuo supporto clienti che verrà visualizzato nella barra laterale del pannello di controllo. Il link deve iniziare con http:// o https://",
  "input.hint.customization.recoverPasswordUrl1":
    "Personalizza l'url di recupero password per i tuoi utenti. Verrà visualizzato nella pagina di accesso alla webmail.",
  "input.hint.customization.upload.logo":
    "Formati supportati: JPG / JPEG / PNG dimensione massima 480 x 96 pixel. Oppure SVG.",
  "input.hint.default.option": "Opz. predefinita",
  "input.hint.disabled.autoresponderOrForwards":
    "Non può essere attivo se ci sono forwards, autorisponditore o la consegna di spam nella inbox abilitate",
  "input.hint.disabled.bounce": "Non può essere attivato quando respingi messaggi è attivo",
  "input.hint.disabled.onDomain": "Disabilitato sul dominio",
  "input.hint.discontinued": "in dismissione",
  "input.hint.included": "incluso nel piano",
  "input.hint.managerAssignedNow": "Ora assegnati: <b>{tot}</b>",
  "input.hint.migration.executeNow": "Con questa opzione la migrazione partirà nel giro di massimo 15 minuti",
  "input.hint.paid.option": "a pagamento",
  "input.hint.passwordScore.check": "Robustezza password",
  "input.hint.passwordScore.easy": "Password molto debole",
  "input.hint.passwordScore.great": "Password ottima!",
  "input.hint.passwordScore.poor": "Password troppo debole",
  "input.hint.passwordScore.strong": "Password robusta",
  "input.hint.passwordScore.weak": "Password debole",
  "input.hint.remembered.devices":
    "Dispositivi sui quali non verrà chiesto il codice OTP. <br/> Quando uno dei dispositivi viene eliminato dalla lista verrà chiesto nuovamente il codice OTP al successivo accesso.",
  "input.hint.ticket.object": "Descrivi il problema in maniera dettagliata.",
  "input.label.access.active_sync": "Attiva sincronizzazione Microsoft® Exchange ActiveSync",
  "input.label.access.chat": "Attiva Chat",
  "input.label.access.dav": "Attiva DAV",
  "input.label.access.imap": "Accesso connessione IMAP",
  "input.label.access.meeting": "Attiva Meeting",
  "input.label.access.pop": "Accesso connessione POP",
  "input.label.access.smtp": "Accesso connessione SMTP",
  "input.label.access.webmail": "Accesso Webmail",
  "input.label.account": "Account",
  "input.label.account.limits.sending": "Limiti di invio account",
  "input.label.account.size": "Dimensione account",
  "input.label.accountsDefaultQuota": "Dimensione predefinita nuovi account",
  "input.label.action": "Azione",
  "input.label.add.alias": "Aggiungi indirizzo alias",
  "input.label.add.destination": "Aggiungi destinazione",
  "input.label.add.ipAddress": "Aggiungi indirizzo IP",
  "input.label.add.ipRestrictions": "Aggiungi restrizioni per IP",
  "input.label.add.sender.bcc": "Aggiungi mittente in Ccn",
  "input.label.add.signature.replies": "Non aggiungere la firma alle risposte",
  "input.label.address": "Via/Piazza",
  "input.label.advanced.csv": "Carica file .CSV avanzato",
  "input.label.antimalware_premium": "Abilita Antimalware e Antivirus Premium",
  "input.label.antispam.level.absent": "Assente",
  "input.label.antispam.level.aggressive": "Aggressivo",
  "input.label.antispam.level.default": "Imposta livello antispam predefinito per gli account del dominio",
  "input.label.antispam.level.standard": "Standard",
  "input.label.antispam.level.tolerant": "Tollerante",
  "input.label.api_enabled": "Abilita accesso via API",
  "input.label.applyDefaultQuotaToAll": "Applica la quota massima in modo retroattivo a tutti gli account",
  "input.label.applyPwdPoliciesToAll": "Applica impostazioni password a tutti gli account in maniera retroattiva",
  "input.label.apply_allow_nets_webmail": "Applica restrizione IP anche alla webmail",
  "input.label.archive.available": "Archivio attivabili",
  "input.label.archiveOnNew": "Attiva archivio su nuovi email account",
  "input.label.audit.action": "Azione",
  "input.label.audit.includeQueryAudits": "Includi ricerche sul registro nei risultati",
  "input.label.audit.medium": "Medium",
  "input.label.audit.target": "Oggetto",
  "input.label.audit.viewAs": "Visualizza come",
  "input.label.audit.who": "Autore",
  "input.label.authorization.expiration": "Scadenza autorizzazione",
  "input.label.authorization.noExpiration": "Autorizzazione senza scadenza",
  "input.label.billing.annually": "Annuale",
  "input.label.billing.cycle": "Fatturazione",
  "input.label.billing.email": "Email area fatturazione",
  "input.label.billing.extraContact": "Specifica un contatto aggiuntivo per la ricezione delle fatture (facoltativo)",
  "input.label.billing.extraContactEmail": "Email",
  "input.label.billing.extraContactFirstname": "Nome",
  "input.label.billing.extraContactLastname": "Cognome",
  "input.label.billing.monthly": "Mensile",
  "input.label.billing.password": "Password area fatturazione",
  "input.label.billing.password.confirm": "Conferma password area fatturazione",
  "input.label.billing.system": "Accesso area clienti",
  "input.label.billing.system.otherCredentials": "Usa altre credenziali per accedere all'area di fatturazione",
  "input.label.block_old_pwd": "Blocca riuso vecchie password",
  "input.label.bounceMsg": "Messaggio di rimbalzo",
  "input.label.callbackURL": "URL callback",
  "input.label.can.haveCatchAll": "Il cliente può avere catch all",
  "input.label.canEditOutboundLimits": "Il cliente può modificare i limiti di invio",
  "input.label.catchAll.address": "Indirizzo catch all",
  "input.label.catchAll.enable": "Abilita indirizzo catch all",
  "input.label.city": "Città",
  "input.label.company": "Azienda",
  "input.label.company.delegate": "Azienda delegato",
  "input.label.country": "Stato",
  "input.label.customer": "Cliente",
  "input.label.customerAreaEmail": "Email area clienti",
  "input.label.customerAreaPassword": "Password area clienti",
  "input.label.customerAreaPassword.confirm": "Conferma password area clienti",
  "input.label.customization.customUrl1": "Link personalizzato (#3)",
  "input.label.customization.custom_url": "URL personalizzato Pannello",
  "input.label.customization.custom_url.mtm": "URL personalizzato Mail Time Machine",
  "input.label.customization.custom_url.vault": "URL personalizzato Vault",
  "input.label.customization.custom_url.webmail": "URL personalizzato Webmail",
  "input.label.customization.domains": "Domini a cui applicare la personalizzazione",
  "input.label.customization.helpDeskUrl": "Link per il supporto clienti (#1)",
  "input.label.customization.preview": "Anteprima personalizzazione Webmail",
  "input.label.customization.recoverPasswordUrl1": "Link per il recupero password (#2)",
  "input.label.customization.upload.logo": "Carica logo",
  "input.label.date.end": "Data fine",
  "input.label.date.expiration": "Data di scadenza",
  "input.label.date.from": "Dal giorno",
  "input.label.date.onDay": "Il giorno",
  "input.label.date.start": "Data inizio",
  "input.label.date.to": "Al giorno",
  "input.label.dateFormats": "Formato data",
  "input.label.default.identity": "Imposta come identità predefinita",
  "input.label.delivery.tracemail.dateRange": "Intervallo date",
  "input.label.description": "Descrizione",
  "input.label.destroy_sessions_on_password_expiration":
    "Forza logout e disabilita i servizi alla scadenza della password",
  "input.label.disable_pwd_change": "Disabilita cambio password",
  "input.label.disable_pwd_recovery": "Disabilita recupero password",
  "input.label.display.name": "Nome visualizzato",
  "input.label.distributor_id": "ID Distributore",
  "input.label.domain": "Dominio",
  "input.label.domain.company": "Nome azienda",
  "input.label.domain.creationNotification": "Notifica quando viene creato un dominio",
  "input.label.domain.limits.sending": "Limiti di invio predefiniti per tutti gli account del dominio",
  "input.label.domain.name": "Nome dominio",
  "input.label.domain.telephone": "Telefono azienda",
  "input.label.domainAlias.name": "Nome dominio alias",
  "input.label.domainsAvailable": "Domini disponibili",
  "input.label.domainsManager": "Assegna domini al manager",
  "input.label.domainsSelected": "Domini selezionati",
  "input.label.dragHere": "Trascina un file qui o clicca per eseguire l'upload",
  "input.label.email": "Email",
  "input.label.email.fax": "Fax",
  "input.label.email.mobilephone": "Cellulare",
  "input.label.email.notification": "Email dove ricevere le notifiche",
  "input.label.email.organizational_unit": "Reparto",
  "input.label.email.role": "Ruolo",
  "input.label.email.secondaryEmail": "Indirizzo email alternativo",
  "input.label.email.teamManager": "Manager del team",
  "input.label.enableAutoresponder": "Abilita risposta automatica",
  "input.label.enableBounceMsg": "Attiva respingi messaggi",
  "input.label.enableIntervals": "Abilita intervallo temporale",
  "input.label.filterBy": "Filtra per",
  "input.label.firstName": "Nome",
  "input.label.firstName.user": "Nome",
  "input.label.fiscalcode": "Codice Fiscale",
  "input.label.fiscalcode2": "Codice Fiscale [se diverso da P. IVA]",
  "input.label.force_otp": "Forza uso autenticazione a due fattori",
  "input.label.force_password_first_login": "Forza cambio password al primo login",
  "input.label.forward.add": "Aggiungi indirizzo di inoltro",
  "input.label.generateNewPassword": "Genera una nuova password per sostituire quella attuale",
  "input.label.hide_from_addressbook_company": "Nascondi utenti in Rubrica Aziendale",
  "input.label.hide_from_addressbook_company_user": "Nascondi utente in Rubrica Aziendale",
  "input.label.hostname": "Hostname",
  "input.label.hours.from": "Dalle ore",
  "input.label.hours.to": "Alle ore",
  "input.label.ignoreSuppressionList": "Ignora lista di soppressione",
  "input.label.import.selectFile": "Seleziona il file da importare",
  "input.label.import.type": "Tipo importazione",
  "input.label.ip.restrictionsToAll": "Applica restrizioni IP a tutti gli account del dominio",
  "input.label.ip.restrictionsToWebmail": "Applica restrizioni IP anche alla webmail",
  "input.label.is.reseller": "Cliente rivenditore",
  "input.label.is.wholesale": "Cliente wholesale",
  "input.label.keepCopy": "Tieni copia dei messaggi sul server",
  "input.label.language": "Lingua",
  "input.label.lastDays": "Ultimi",
  "input.label.lastName": "Cognome",
  "input.label.lastName.user": "Cognome",
  "input.label.login.remeber": "Ricorda per questo dispositivo per 30 giorni",
  "input.label.maxAccountsAvailable100": "Max account 100GB attivabili",
  "input.label.maxAccountsAvailable25": "Max account 25GB attivabili",
  "input.label.maxAccountsAvailable50": "Max account 50GB attivabili",
  "input.label.maxAccountsAvailable8": "Max account attivabili",
  "input.label.maxAccountsSize": "Dimensione massima account",
  "input.label.maxArchiveAvailable": "Max archivio attivabili",
  "input.label.maxDeliveryFree": "Max numero di account Delivery free",
  "input.label.maxDomainsAvailable": "Max domini attivabili",
  "input.label.maxNewDeliveryAccountsAvailable": "Max nuovi account per l'invio",
  "input.label.maxNewDeliveryDomainsAvailable": "Max nuovi domini per l'invio",
  "input.label.message.body": "Testo messaggio",
  "input.label.message.subject": "Oggetto messaggio",
  "input.label.migration.executeNow": "Esegui prima migrazione appena possibile",
  "input.label.migration.masteruser": "Migrazione con Masteruser",
  "input.label.migration.secondExecHour": "Seconda esecuzione dopo",
  "input.label.migration.selectFile": "Seleziona il file da migrare",
  "input.label.migration.startDate": "Data avvio migrazione",
  "input.label.mx1": "MX 1",
  "input.label.mx2": "MX 2",
  "input.label.otpCode": "Inserisci il codice generato dall'applicazione",
  "input.label.override_plan_num_messages": "Mantieni questo valore ({value}) anche nei prossimi rinnovi.",
  "input.label.password": "Password",
  "input.label.password.forceChange.nextLogin": "Forza cambio password al prossimo login",
  "input.label.password.forceChange.nextLogin.domain":
    "Forza cambio password al prossimo login sugli account del dominio",
  "input.label.password.new": "Nuova password",
  "input.label.password.old": "Veccchia password",
  "input.label.password.postmaster": "Password postmaster",
  "input.label.passwordConfirm": "Conferma password",
  "input.label.passwordConfirm.new": "Conferma nuova password",
  "input.label.passwordConfirm.postmaster": "Conferma password postmaster",
  "input.label.password_expiration_counter_start": "Il conteggio dei {months} mesi inizerà da oggi",
  "input.label.personalData": "Contratto di nomina di Qboxmail Srl a Responsabile del trattamento",
  "input.label.postcode": "CAP",
  "input.label.privacy": "Informativa sulla Privacy",
  "input.label.promocode": "Codice promozionale",
  "input.label.protocol": "Protocollo di accesso",
  "input.label.pwd_expiration": "Imposta scadenza password degli account del dominio",
  "input.label.pwd_expiration.12": "12 mesi",
  "input.label.pwd_expiration.3": "3 mesi",
  "input.label.pwd_expiration.6": "6 mesi",
  "input.label.pwd_expiration.never": "Mai",
  "input.label.pwd_expiration_email": "Imposta scadenza password dell'email account",
  "input.label.quotaExceeded": "Notifica quando l'account è vicino alla quota massima",
  "input.label.quoteSelector.included": "Compreso nel piano",
  "input.label.quoteSelector.upgradeL": "Upgrade Large",
  "input.label.quoteSelector.upgradeM": "Upgrade Medium",
  "input.label.quoteSelector.upgradeXL": "Upgrade XL",
  "input.label.recipient": "Destinatario",
  "input.label.recipientCode": "Codice Destinatario per fatturazione elettronica",
  "input.label.remembered.devices": "Dispositivi ricordati",
  "input.label.restore_plan_num_messages": "Ripristina il valore predefinito del piano ({value})",
  "input.label.retention": "Seleziona anni di archiviazione",
  "input.label.select.country": "Seleziona il paese",
  "input.label.select.countryEmail": " Paese in cui l'utente opera",
  "input.label.select.identity": "Seleziona identità",
  "input.label.select.payment.frequency": "Seleziona la frequenza di pagamento",
  "input.label.select.payment.method": "Seleziona metodo di pagamento",
  "input.label.select.plan": "Seleziona piano",
  "input.label.select.usert.type": "Seleziona la tipologia di utente che ti rappresenta",
  "input.label.select.verificationEmail": "Scegli dove ricevere il codice di verifica",
  "input.label.selectAll": "Seleziona tutti",
  "input.label.selectMboxes": "Seleziona account email",
  "input.label.sender": "Mittente",
  "input.label.sentLimits": "Limiti di invio dell'account",
  "input.label.sentLimits.defautl": "Limiti di invio predefiniti per tutti gli account del dominio",
  "input.label.sentMsg24h": "{msgNumber} messaggi ogni {hours} ore {option}",
  "input.label.sentMsg24h.domainDefault": "Limiti di invio come dominio {option}",
  "input.label.serverSource": "Selezione tipo di server sorgente",
  "input.label.signature.apply.toAll": "Applica la firma a tutti gli account del dominio",
  "input.label.signature.apply.toNew": "Applica automaticamente la firma a tutti i nuovi account email",
  "input.label.signature.apply.toWhitout": "Applica la firma a tutti gli account che ancora non ne hanno una",
  "input.label.signature.text": "Testo firma",
  "input.label.spamInInbox": "Consegna spam in Inbox",
  "input.label.state": "Provincia",
  "input.label.telephone": "Telefono",
  "input.label.terms": "Clausole e condizioni contrattuali relative al Servizio Qboxmail",
  "input.label.timeFormats": "Formato ora",
  "input.label.timezone": "Fuso orario",
  "input.label.tracemail21DaysLimit": "Limita visibilità log a 21 giorni",
  "input.label.tracemail21DaysLimitDefault": "Limita visibilità log a 21 giorni per tutti i nuovi domini",
  "input.label.username": "Nome utente",
  "input.label.vat": "Partita IVA",
  "input.label.verify.code": "Codice di verifica",
  "input.label.visualization.always": "Visione contenuto archivio senza limiti temporali",
  "input.label.visualization.end": "Visione contenuti fino al giorno",
  "input.label.visualization.start": "Visione contenuti dal giorno",
  "input.label.volume": "Messaggi disponibili",
  "input.label.whmcs_id": "ID WHMCS",
  "input.placeholder.Loading": "Loading...",
  "input.placeholder.account.select": "Seleziona utenza",
  "input.placeholder.address": "Indirizzo",
  "input.placeholder.audit.searchMsg": "Digita le prime 4 lettere di un account email o di un codice utente",
  "input.placeholder.audit.viewAs": "Cerca account o ID",
  "input.placeholder.city": "Città",
  "input.placeholder.company": "Azienda",
  "input.placeholder.country": "Stato",
  "input.placeholder.customerSelect": "Nome o codice cliente",
  "input.placeholder.delivery.description": "Descrizione",
  "input.placeholder.delivery.tracemail.account": "Nome utenza o ID utenza",
  "input.placeholder.delivery.tracemail.messageSubject": "Oggetto del messaggio inviato",
  "input.placeholder.delivery.tracemail.recipient": "Indirizzo email del destinatario",
  "input.placeholder.delivery.tracemail.sender": "Indirizzo email del mittente",
  "input.placeholder.domain.hint": "Inizia digitare il nome del dominio o il codice per cercare",
  "input.placeholder.domain.name": "dominio.it",
  "input.placeholder.domain.notFound": "Nessun dominio trovato",
  "input.placeholder.domain.select": "Seleziona dominio",
  "input.placeholder.domainCustomer": "Nome dominio o codice cliente",
  "input.placeholder.email": "Indirizzo email",
  "input.placeholder.email.hint": "Seleziona prima il dominio per vedere la lista delle email",
  "input.placeholder.fax": "Fax",
  "input.placeholder.filters": "Cerca",
  "input.placeholder.firstName": "Nome",
  "input.placeholder.fiscalcode": "Codice fiscale",
  "input.placeholder.helpDeskUrl.label": "e.s. Clicca qui per...",
  "input.placeholder.id": "ID",
  "input.placeholder.ip": "e.s. 192.123.12.32",
  "input.placeholder.lastName": "Cognome",
  "input.placeholder.message.subject": "Oggetto",
  "input.placeholder.mobilephone": "Cellulare",
  "input.placeholder.myOtherEmail": "altraemail@dominio.it",
  "input.placeholder.noFoundCustomers": "Nessun cliente trovato",
  "input.placeholder.noMatchess": "Nessuna corrispondenza per: ",
  "input.placeholder.organizational_unit": "Reparto",
  "input.placeholder.password": "Password",
  "input.placeholder.postcode": "CAP",
  "input.placeholder.promocode": "Codice Promozionale",
  "input.placeholder.pwdRules": "8 o più caratteri alfanumerici",
  "input.placeholder.recipientCode": "Codice numerico o indirzzo PEC",
  "input.placeholder.role": "Ruolo",
  "input.placeholder.state": "Provincia",
  "input.placeholder.status": "Status",
  "input.placeholder.telephone": "Telefono",
  "input.placeholder.token.generating": "Generazione token...",
  "input.placeholder.token.generation": "Generando il token...",
  "input.placeholder.token.reset": "Reset...",
  "input.placeholder.url": "https://...",
  "input.placeholder.url_callback": "https://yoursite.com/callbackme",
  "input.placeholder.username": "Email o User ID",
  "input.placeholder.vat": "Partita IVA",
  "label.billing.monthly": "Canone mensile",
  "label.billing.prepaid": "Totale",
  "label.billing.resellerPrice": "Prezzo rivenditori",
  "label.password": "Password",
  "label.username": "Username",
  "listTable.header.title.accounts.active": "Account attivi",
  "listTable.header.title.alias": "Indirizzi alias",
  "listTable.header.title.browser": "Browser",
  "listTable.header.title.destinations": "Destinazioni",
  "listTable.header.title.forwards": "Indirizzi di inoltro",
  "listTable.header.title.ip": "IP / record",
  "listTable.header.title.ipEnabled": "Indirizzi IP abilitati all'accesso",
  "listTable.header.title.name": "Nome",
  "listTable.header.title.platform": "Piattaforma",
  "listTable.header.title.signature.displayName": "Nome visualizzato",
  "listTable.header.title.signature.identity": "Identità",
  "listTable.header.title.type": "Type",
  "listTable.placeholder": "Aggiungi elemento alla lista",
  "listTable.placeholder.signature": "Aggiungi la tua prima identità",
  "loading.msg.data": "Caricamento dati",
  "loading.msg.token": "Verifica validità token",
  "login.footer.cookiePolicy": "Cookie Policy",
  "login.footer.privacyPolicy": "Privacy Policy",
  "login.footer.version": "Versione",
  "login.screen.desc": "Organizza le email della tua azienda",
  "login.screen.title": "Pannello di controllo",
  "mailbox.intro.description":
    "In un'unica console trovi strumenti per creare, gestire, e analizzare caselle email in totale autonomia.<br />Importa e gestisci tutte le caselle email dei tuoi utenti anche su più domini.<br />Crea ruoli specifici per i tuoi collaboratori e clienti, assegnando privilegi e limiti.<br />Monitora le attività attraverso specifici strumenti di analisi e reportistica.",
  "mailbox.intro.title": "Email Hosting",
  "managers.add.desc.step1":
    "Inserisci le informazioni di contatto e imposta una password per il manager. Una volta creato potrai impostare il numero di email account e archivi attivabili dal manager e assegnagli i domini da gestire.",
  "managers.add.title.step1": "Nuovo manager",
  "managers.list.header.dsc":
    "I Manager hanno accesso alle impostazioni dei domini loro assegnati e degli account in essi presenti secondo le limitazioni impostate dall'amministratore.",
  "managers.list.header.title": "Manager",
  "managers.settings.deliverySettings.assignResource.modalTitle": "Assegna risorsa al manager",
  "migration.step.label1": "Prima migrazione",
  "migration.step.label2": "Cambia i record MX",
  "migration.step.label3": "Seconda migrazione",
  "migration.step.text1": "La maggior parte dei messaggi verranno migrati durante questa fase.",
  "migration.step.text2":
    "Una volta completata la prima migrazione, riceverai un'email e dovrai modificare i record MX. Dopo la modifica dei record i messaggi iniziano ad arrivare sui nostri server.",
  "migration.step.text3":
    "I nuovi messaggi stanno già arrivando sui nostri server. Con questa ultima fase verranno recuperati eventuali messaggi ancora presenti sul tuo vecchio provider.",
  "migration.step.title": "Configura la tua migrazione",
  "migration.step.warning3": "Scegli un orario che ti consenta di modificare i record MX.",
  "migrationOptions.list.header.title": "Opzioni migrazione",
  "migrations.add.desc":
    "Crea il file .CSV con le informazioni necessarie e trasferisci il contenuto dei tuoi account email dal tuo vecchio server/provider.",
  "migrations.add.title": "Nuova migrazione",
  "migrations.list.header.dsc":
    "Le Migrazioni consentono di trasferire i messaggi email dal vecchio server/provider via IMAP attraverso un file .CSV.",
  "migrations.list.header.title": "Migrazioni",
  "migrations.resources.details": "Dettagli",
  "migrations.resources.header.title": "Migrazione",
  "migrations.resources.runDetailsCrashed": "Si è verificato un errore durante l'operazione. Contatta il supporto.",
  "migrations.resources.runDetailsInterrupted": "La migrazione è stata interrotta con i seguenti errori:",
  "migrations.resources.runDetailsSuccess": "L'operazione è stata completata con successo.",
  "modal.add.destination.title": "Aggiungi destinazione",
  "modal.cantDowngradeBasic.desc":
    "Per effettuare il downgrade al piano basic devi prima ridurre la dimensione delle caselle da 50GB di questo dominio, in quanto questa opzione non è prevista da questo piano.",
  "modal.cantDowngradeBasic.title": "Non puoi effettuare il downgrade a Basic",
  "modal.change.password.title": "Cambia password",
  "modal.change.passwordExpired.title": "La tua password è scaduta, cambiala ora:",
  "modal.delete.archive.delegate.text":
    "Stai eliminando il delegato <code>{name}</code>.<br/><b>L'operazione non è reversibile.</b>",
  "modal.delete.archive.delegate.title": "Elimina delegato",
  "modal.delete.archive.domain.text":
    "Stai eliminando l'archivio del dominio <code>{domain}</code>.<br/>Tutti i messaggi archiviati verranno cancellati.<br/><b>L'operazione non è reversibile.</b>",
  "modal.delete.archive.domain.title": "Elimina archivio dominio",
  "modal.delete.archive.emailAccount.text":
    "Stai eliminando l'archivio dell'account <code>{emailAccount}</code>.<br/>Tutti i messaggi archiviati verranno cancellati.<br/><b>L'operazione non è reversibile.</b>",
  "modal.delete.archive.emailAccount.title": "Elimina archivio account",
  "modal.delete.customization.text":
    "Stai eliminando la personalizzazione per l'azienda <code>{company}</code>.<br/><b>L'operazione non è reversibile.</b>",
  "modal.delete.customization.title": "Elimina personalizzazione",
  "modal.delete.deliveryAccount.checkboxMsg":
    "Mantieni l'utenza attiva fino al termine del ciclo di fatturazione e poi elimina automaticamente.",
  "modal.delete.deliveryAccount.text.free": "Stai tentando di eliminare l'utenza {accountData}.",
  "modal.delete.deliveryAccount.text.monthly":
    "Stai tentando di eliminare l'utenza {accountData}. Cancellando l'utenza perderai gli indirizzi in lista di soppressione collegati all'utenza: se non l'hai ancora fatto, esporta la lista prima di eliminare l'utenza.</br></br>L'utenza dispone di un piano di abbonamento: puoi scegliere di eliminare l'utenza subito o al termine del ciclo di fatturazione.",
  "modal.delete.deliveryAccount.text.prepaid":
    "Stai tentando di eliminare l'utenza {accountData}. Cancellando l'utenza perderai gli indirizzi in lista di soppressione collegati all'utenza: se non l'hai ancora fatto, esporta la lista prima di eliminare l'utenza.</br></br>L'utenza dispone di un credito di invii ancora da effettuare. Eliminando l'utenza il credito verrà perso.",
  "modal.delete.deliveryAccount.title": "Elimina l'utenza",
  "modal.delete.deliveryAccount.warningMsg": "L'operazione non è reversibile",
  "modal.delete.deliveryDomain.text":
    "Stai tentando di eliminare il dominio <code>{domainName}</code>. Cancellando il dominio perderai la possibilità di inviare tramite il protocollo SMTP e verranno eliminate le associazioni utenza-domini.",
  "modal.delete.deliveryDomain.title": "Elimina dominio da Email Delivery",
  "modal.delete.emailAccount.text":
    "Stai eliminando l'email account <code>{emailAccount}</code>.<br/><b>L'operazione non è reversibile.</b>",
  "modal.delete.emailAccount.title": "Elimina email account",
  "modal.delete.import.text":
    "Stai eliminando l'importazione <code>{importCode}</code>.<br/><b>L'operazione non è reversibile.</b>",
  "modal.delete.import.title": "Elimina importazione",
  "modal.delete.manager.text":
    "Stai eliminando il manager <code>{name}</code>.<br/><b>L'operazione non è reversibile.</b>",
  "modal.delete.manager.title": "Elimina manager",
  "modal.delete.migration.text":
    "Stai eliminando la migrazione <code>{migrationCode}</code>.<br/><b>L'operazione non è reversibile.</b>",
  "modal.delete.migration.title": "Elimina migrazione",
  "modal.delete.teamMember.text":
    "Stai eliminando il team member <code>{name}</code>.<br/><b>L'operazione non è reversibile.</b>",
  "modal.delete.teamMember.title": "Elimina team member",
  "modal.disable.archive.domain.text": "Stai disattivando l'archivio del dominio <code>{domain}</code>.",
  "modal.disable.archive.domain.title": "Disattiva archivio dominio",
  "modal.disable.archive.emailAccount.text": "Stai disattivando l'archivio dell'account <code>{emailAccount}</code>.",
  "modal.disable.archive.emailAccount.title": "Disattiva archivio account",
  "modal.disable.emailAccount.text":
    "Stai disattivando l'email account <code>{emailAccount}</code>.<br/>Non verranno più ricevuti messaggi, i mittenti riceveranno un messaggio di rimbalzo.<br/>Se su questo account è attivo il servizio archivio i nuovi messaggi ricevuti non verrano archiviati. Potrai comunque accedere all’archivio e consultare i vecchi messaggi.<br/>Ti consigliamo di cambiare preventivamente la password dell'Account se vuoi inibire l'accesso al suo archivio a chi conosce l'attuale password.<br/><b>Eventuali messaggi di risposta automatica o inoltro messaggi verranno rimossi.</b>",
  "modal.disable.emailAccount.title": "Disattiva email account",
  "modal.enable.emailAccount.text":
    "Stai riattivando l'email account <code>{emailAccount}</code>.<br/>I messaggi verranno nuovamente ricevuti, il messaggio di rimbalzo verrà disabilitato e tutti i servizi torneranno attivi.<br/>Se su questa casella è attivo il servizio Archivio Email i nuovi messaggi riprenderanno a essere archiviati.",
  "modal.enable.emailAccount.title": "Riattiva email account",
  "modal.etlive.whereIsTitle": "Esito della ricerca",
  "modal.firstLogin.password.desc":
    "Abbiamo aggiornato il nostro pannello, ora potrai accedere a tutti i tuoi account tramite un'unica password.<br/>Imposta una nuova password per tutti account collegati all'indirizzo <code>{emailAccount}</code>.",
  "modal.firstLogin.password.title": "Imposta nuova password",
  "modal.import.archive.text":
    "L’importazione risalirà a ritroso di <code>{retentionAccount} {duration}</code>.<br/>Seleziona le cartelle da cui vuoi importare i messaggi e scegli dove archiviare il loro contenuto. Tutti i messaggi delle cartelle selezionate verranno suddivisi e organizzati per anno.<br/><br/><b>Ricevuti:</b> archivia il contenuto delle cartelle in ricevuti<br/><b>Inviati:</b> archivia il contenuto delle cartelle in inviati<br/><b>Ignora:</b> il contenuto della cartella non viene archiviato<br/>",
  "modal.import.archive.title": "Importa messaggi in archivio",
  "modal.import.started.archive.text":
    "Tutti i messaggi presenti nel tuo email account, verranno importati e suddivisi per anno, ordinanti in inviati e ricevuti, come da te scelto.",
  "modal.import.started.archive.title": "Importazione messaggi avviata",
  "modal.log.migration.detail.title": "Dettagli migrazione",
  "modal.log.migration.title": "Log migrazione",
  "modal.manager.delivery.confirm.body": "Sei sicuro di vuol rimuovere la gestione di <b>{resource}</b> al manager?",
  "modal.manager.delivery.confirm.title": "Rimuovi risorsa dal manager",
  "modal.mx.customer.desc":
    "Può essere lasciato vuoto in caso gli MX personalizzati non siano associati a nessun cliente",
  "modal.noAction.title": "Azione non consentita",
  "modal.otp.access.desc":
    "Inserisci la password temporanea generata con l'applicazione Google Authenticator® per accedere al pannello di controllo.",
  "modal.otp.access.title": "One Time Password",
  "modal.otp.app.desc":
    "Per attivare e iniziare a utilizzare l’autenticazione tramite OTP scarica e installa sul tuo dispositivo mobile l’applicazione:",
  "modal.otp.app.title": "Autenticazione OTP",
  "modal.otp.disable.desc":
    "Inserisci la password temporanea generata con l'applicazione Google Authenticator® per disabilitare l’autenticazione OTP.<br/>Potrai riattivare l’autenticazione tramite OTP accedendo alle impostazioni del tuo account.",
  "modal.otp.disable.title": "Disabilita OTP per questo account",
  "modal.otp.enable.desc":
    "Scansiona il QRCode con l'applicazione Google Authenticator® o inserisci il codice manualmente e utilizza la password temporanea generata per attivare l’autenticazione OTP.",
  "modal.otp.enable.title": "Attiva OTP per questo account",
  "modal.paidOption.desc":
    "Hai selezionato un'opzione a pagamento, salvando le impostazioni verrà aggiunta alla prossima fattura.",
  "modal.paidOption.title": "Opzione a pagamento",
  "modal.planDowngradeBasic.desc":
    "Passando al piano Basic <b>perderai</b> per tutte le caselle email del dominio: <br /> <ul><li class='ml-5'>• Caselle email fino a 50 GB</li><li class='ml-5'>• Calendario e Rubrica condivisi (compresi tutti i dati)</li><li class='ml-5'>• Gestione centralizzata delle firme</li><li class='ml-5'>• Alcune opzioni di sicurezza</li><li class='ml-5'>• Logo personalizzato per il dominio</li><li class='ml-5'>• Antimalware Premium</li></ul> <br />Sei sicuro di voler procedere?",
  "modal.planDowngradeBasic.title": "Downgrade del piano a Basic",
  "modal.planDowngradeProfessional.desc":
    "Passando al piano Professional <b>perderai</b> per tutte le caselle email del dominio: <br /> <ul><li class='ml-5'>• Caselle email fino a 100 GB</li><li class='ml-5'>• Microsoft® Exchange ActiveSync</li><li class='ml-5'>• Alcune opzioni di sicurezza</li></ul> <br />Sei sicuro di voler procedere?",
  "modal.planDowngradeProfessional.title": "Downgrade del piano a Professional",
  "modal.planUpgradeEnterprise.desc":
    "Passando al piano Enterprise avrai a disposizione per tutte le caselle email del dominio: <br /> <ul><li class='ml-5'>• Tutte le funzionalità del Professional</li><li class='ml-5'>• Caselle email fino a 100 GB</li><li class='ml-5'>• Microsoft® Exchange ActiveSync</li><li class='ml-5'>• Ulteriori opzioni di sicurezza</li></ul> <br />Vuoi procedere?",
  "modal.planUpgradeEnterprise.title": "Upgrade del piano a Enterprise",
  "modal.planUpgradeProfessional.desc":
    "Passando al piano Professional avrai a disposizione per tutte le caselle email del dominio: <br /> <ul><li class='ml-5'>• Caselle email fino a 50 GB</li><li class='ml-5'>• Calendario e Rubrica condivisi</li><li class='ml-5'>• Gestione centralizzata delle firme</li><li class='ml-5'>• Maggiori opzioni di sicurezza</li><li class='ml-5'>• Logo personalizzato per il dominio</li><li class='ml-5'>• Antimalware Premium</li> </ul> <br/>Vuoi procedere?",
  "modal.planUpgradeProfessional.title": "Upgrade del piano a Professional",
  "modal.recoveryPassword.desc":
    "Per recuperare la password e accedere al pannello di controllo, inserisci il tuo indirizzo email di recupero e segui le istruzioni che ti invieremo.",
  "modal.recoveryPassword.disabled": "Il recupero password per questo account è <b>disabilitato</b>.",
  "modal.recoveryPassword.title": "Recupera password",
  "modal.reseller.desc":
    "Per rivenditore si intende chi acquista i servizi di Qboxmail principalmente per rivenderli a terzi, deve essere in possesso Partita IVA e può effettuare esclusivamente ordini con fatturazione mensile.<br/><b>La qualifica di rivenditore è soggetta ad approvazione.</b>",
  "modal.reseller.title": "Rivenditore",
  "modal.resellerOrCompany.company.desc":
    "Scegli questa opzione se utilizzerai il servizio di Qboxmail per <b>gestire le caselle email della tua azienda.</br>",
  "modal.resellerOrCompany.company.input.label": "Sono un'azienda",
  "modal.resellerOrCompany.company.title": "Per le aziende",
  "modal.resellerOrCompany.desc":
    "Sei un rivenditore o un'azienda?<br/>Ottimizzeremo la tua esperienza sul Pannello di Controllo in base alla tua scelta.",
  "modal.resellerOrCompany.reseller.desc":
    "Scegli questa opzione se utilizzerai il servizio di Qboxmail per <b>gestire le caselle email dei tuoi clienti.</b>",
  "modal.resellerOrCompany.reseller.input.label": "Sono un rivenditore",
  "modal.resellerOrCompany.reseller.title": "Per i rivenditori",
  "modal.resellerOrCompany.submitButton": "Conferma",
  "modal.resellerOrCompany.title": "Benvenuto! Ottimizza il tuo Pannello di Controllo",
  "modal.reset.password.title": "Rest password",
  "modal.restore.deliveryAccount.text.free":
    "Se ripristini il servizio, l'abbonamento dell'utenza riprenderà il suo corso.",
  "modal.restore.deliveryAccount.title": "Ripristina servizio utenza",
  "modal.settingsWebmail.signature.applyTo.desc.1":
    "Tutti gli account email del dominio hanno già una firma configurata.",
  "modal.settingsWebmail.signature.applyTo.desc.2":
    "Il modello della firma verrà applicato a tutti gli account email, elencati di seguito, che ancora non hanno una firma configurata:",
  "modal.settingsWebmail.signature.applyTo.title": "Applica firma agli account",
  "modal.settingsWebmail.signature.applyToAll.desc":
    "Il modello della firma verrà applicato a tutti gli account email del dominio.<br/>Eventuali firme già presenti verranno sovrascritte.<br/><b>L'operazione non è reversibile.</b>",
  "modal.settingsWebmail.signature.applyToAll.title": "Applica firma a tutti",
  "modal.settingsWebmail.signature.missingField.desc.1": "Alcuni account email del dominio non dispongono del campo",
  "modal.settingsWebmail.signature.missingField.desc.2":
    "Utilizzando questa variabile, il campo corrispondente risulterà vuoto per questi account.",
  "modal.settingsWebmail.signature.missingField.title": "Account email senza campo",
  "modal.trial.days.left": "Giorni rimanenti",
  "modal.trial.desc":
    "Al termine del periodo di prova l'account verrà disabilitato. Non aspettare l'ultimo momento!<br/><b>Acquista subito e sblocca le funzionalità avanzate.</b>",
  "modal.trial.desc.endTrial":
    "Il tuo account è stato disabilitato.<br/><b>Acquista i servizi per riabilitare l'account e sbloccare le funzionalità avanzate.</b>",
  "modal.trial.title": "Periodo di prova",
  "modal.ugradeRequired.plan.title": "Upgrade piano necerrario",
  "modal.ugradeRequired.quota.desc":
    "Per aumentare le dimensioni di uno o più account email, è necessario fare l'upgrade del piano del dominio. Attiva il <b>piano Professional per avere fino a 50 GB</b> di spazio per i tuoi account o il <b> piano Enterprise per account da 100 GB</b>. <br/> <br/> Per fare l'upgrade del piano del dominio vai su <code> Impostazioni dominio >  Generali > Gestione piano</code> e seleziona il piano corrispondente alle tue esigenze.",
  "modal.withArchive.domain":
    "Questo dominio ha l'archivio attivo, quindi non può essere eliminato. Elimina prima l'archivio per eliminare il dominio.",
  "modal.withArchive.emailAccount":
    "Questo email account ha l'archivio attivo, quindi non può essere eliminato. Elimina prima l'archivio per eliminare l'account.",
  "mtm.cardDayLabel": "Backup richiesto:",
  "mtm.cardHeader": "Ripristino richiesto il {date}",
  "mtm.cardMailLabel": "Casella:",
  "mtm.completed": "Ripristino completato con successo",
  "mtm.denied": "Richiesta rifiutata",
  "mtm.errored": "Errore durante il ripristono. Contatta il supporto.",
  "mtm.expired": "Backup scaduto",
  "mtm.expiresAtLabel": "Backup disponibile fino",
  "mtm.noRequests": "Nessuna richiesta di ripristino",
  "mtm.pendingRequests": "Hai richieste di ripristino backup in sospeso",
  "mtm.running": "Ripristino in corso",
  "mtm.sectionDesc": "Qui puoi gestire le richieste di ripristino inviate dai tuoi utenti tramite la Mail Time Machine",
  "mtm.sectionTitle": "Richieste di ripristino",
  "mxrecords.list.desc":
    "Mostra i gli MX personalizzati configurati per i private Gestisci gli MX personalizzati per i private label",
  "mxrecords.list.title": "MX personalizzati",
  "navbar.appSwitch.mailboxes": "Email Hosting",
  "navbar.trial.end.warningMsg": "Il tuo periodo di prova è terminato",
  "navbar.trial.waitPay": "Hai un ordine in attesa di pagamento",
  "navbar.trial.warningMsg": "Il periodo di prova terminerà fra {daysLeft} p{giorno/giorni}",
  "order.add.congratulation.desc":
    "A breve riceverai una email, all'indirizzo <code>{email}</code>, con il riepilogo del tuo ordine e le istruzioni per eseguire il pagamento.",
  "order.add.congratulation.orderNumber": "Il numero del tuo ordine è <code>{code}</code>.",
  "order.add.congratulation.subtitle":
    "Una volta ricevuto il pagamento il servizio verrà attivato nel giro di poche ore.",
  "order.add.congratulation.title": "Grazie per aver ordinato i servizi di Qboxmail",
  "order.add.desc.step1":
    "Seleziona il paese in cui ha sede la tua azienda o, se sei un utente privato, il paese in cui sei residente.",
  "order.add.desc.step2":
    "Indica se intendi utilizzare il servizio solo per te, o per la tua azienda, o se intendi acquistarlo per rivenderlo a terzi.",
  "order.add.desc.step3":
    "Per procedere con l’ordine abbiamo bisogno dei tuoi dati o della azienda a cui verrà intestato il servizio.",
  "order.add.desc.step4":
    "Scegli il tipo di fatturazione e il metodo di pagamento che più si adatta alle tue esigenze.",
  "order.add.desc.step5.annual":
    "Seleziona tutti i domini e gli email account di cui hai bisogno, scegliendo il piano più adatto alle tue esigenze. Una volta completato l'ordine, sarai in grado di attivare i domini e gli account che hai scelto.",
  "order.add.desc.step5.monthly":
    "Questi sono i tuoi domini e gli email account attualmente attivi. Una volta completato l'ordine i limiti dal tuo utente verranno rimossi e potrai attivare nuovi domini e account.",
  "order.add.desc.step7": "Le istruzioni per il pagamento verranno inviate a <code>{emailAddress}</code>.",
  "order.add.title.step1": "Area geografica",
  "order.add.title.step2": "Tipologia utente",
  "order.add.title.step3": "Informazioni di contatto",
  "order.add.title.step4": "Fatturazione e metodi di pagamento",
  "order.add.title.step5": "Domini e email account ",
  "order.add.title.step6": "Riepilogo ordine",
  "order.counter.addAccounts": "Inserisci il numero di <b>email account</b> che vuoi aggiungere al tuo dominio.",
  "order.counter.archive": "Opzioni Archivio Email",
  "order.counter.emailAccount.100GB": "Email account 100GB",
  "order.counter.emailAccount.50GB": "Email account 50GB",
  "order.counter.emailAccout.25GB": "Email account 25GB",
  "order.counter.emailAccout.8GB": "Email account 8GB",
  "order.counter.paidOptions":
    "Inserisci il numero di <b>opzioni aggiuntive</b> che vuoi attivare suoi tuoi email account.",
  "order.counter.price.annual": "anno",
  "order.counter.price.monthly": "mese",
  "order.fee.invoiceCalc.monthly":
    "La cifra indicata si riferisce all’intero mese. L'importo esatto verrà calcolato in base alla data di completamento dell’ordine.",
  "order.fee.priceVat": "Tutti i prezzi si intendono <b>IVA esclusa</b>.",
  "order.label.first.bill.annual": "Canone annuale",
  "order.label.first.bill.annualTotal": "Canone annuale totale",
  "order.label.first.bill.monthly": "Canone mensile",
  "orders.list.card.field.date": "Data ordine",
  "orders.list.card.field.dateEdit": "Modifica ordine",
  "orders.list.card.field.dateExpire": "Data scadenza",
  "orders.list.card.field.em25gb": "Email account 25 GB",
  "orders.list.card.field.em8gb": "Email account 8 GB",
  "orders.list.card.field.emArchive": "Archivi email",
  "orders.list.card.field.plan": "Piano",
  "orders.list.card.field.total": "Totale ordine",
  "orders.list.card.field.waitingPayment": "In attesa di pagamento",
  "orders.list.header.dsc": " ",
  "orders.list.header.newDomain": "Ordina dominio",
  "orders.list.header.title": "Ordini",
  "orders.new.alert.noDomainsWithNoEmails": "Non è possibile ordinare un dominio senza caselle email",
  "orders.new.alert.noEmptyOrder": "Non è possibile completare un'ordine senza caselle",
  "orders.new.alert.noIncompleteDomains": "Completa le informazioni di tutti i domini",
  "orders.new.recap.addedForMinimum": "Account email aggiunti per ordine minimo",
  "orders.new.recap.price": "prezzo € {price}",
  "orders.new.recap.resellerWarn":
    "Se sei un rivenditore, potrai richiedere lo sconto rivenditori a partire dal secondo mese di fatturazione nella pagina prezzi del Pannello.",
  "orders.show.calc.action.question": "Che tipo di upgrade vuoi eseguire sul dominio?",
  "orders.show.calc.whmcs.total": "Calcola canone",
  "orders.show.step1.desc":
    "Effettua l'upgrade del tuo dominio, modificando il piano attuale ad esso asseganto o il numero di email account attivabili.",
  "orders.show.step1.desc.emails":
    "Aggiungi nuovi email account o aumenta il numero delle opzioni aggiuntive che è possibile attivare per gli account del tuo dominio.",
  "orders.show.step1.desc.plan": "Effettua l'upgrade del piano del tuo dominio e accedi alle funzionalità avanzate.",
  "orders.show.step1.title": "Upgrade dominio",
  "orders.show.step1.title.emails": "Aggiungi email account",
  "orders.show.step1.title.plan": "Upgrade piano",
  "ownershipCheck.dns.instruction.part1":
    "Per superare questa verifica devi accedere al pannello di gestione DNS del tuo dominio, creare il record di tipo A sotto specificato e farlo puntare all'IP indicato:",
  "ownershipCheck.dns.instruction.part2":
    "Una volta creato il record DNS puoi premere il pulsante <code>Verifica DNS</code> per attivare il dominio. Potrebbero essere necessarie fino a 24 ore prima che la modifica al DNS del dominio sia operativa.<br/>Ultima verifica effettuata: ",
  "ownershipCheck.email.instruction.part1":
    "Verifica la proprietà del dominio tramite codice. Scegli un indirizzo, tra quelli indicati, in cui ricevere il codice di verifica.",
  "ownershipCheck.email.instruction.part2":
    "Abbiamo inviato una email a <code>{emailAddress}</code>.<br/>Utilizza il codice di verifica che trovi nel messaggio per completare l'operazione.",
  "ownershipCheck.html.instruction.part1":
    "Verifica la proprietà del dominio tramite file, generato dai nostri sistemi, da aggiungere alla root del sito.",
  "ownershipCheck.html.instruction.step1.title": "1. Scarica il file di verifica",
  "ownershipCheck.html.instruction.step2.desc1":
    "Carica il file nella root del sito associato al dominio, senza cambiarne nome o contenuto, facendo in modo che il file sia visibile all'url:",
  "ownershipCheck.html.instruction.step2.desc2":
    "Se cliccando su questo link ottieni un errore 404 o sei rimandato a una pagina del sito web il file non è caricato correttamente.",
  "ownershipCheck.html.instruction.step2.title": "2. Carica il file nella root del sito",
  "ownershipCheck.html.instruction.step3.desc1":
    "Se il file è posizionato correttamente, completa la pocedura cliccando su <code>Verifica</code>",
  "ownershipcheck.title": "Verifica proprietà dominio",
  "plan.basic.desc": "Per i professionisti o le aziende che vogliono un servizio conveniente e di qualità.",
  "plan.basic.fullName": "Piano Basic",
  "plan.basic.name": "Basic",
  "plan.enterprise.desc":
    "Per le organizzazioni che necessitano di strumenti di comunicazione avanzata per i proprio collaboratori e di una sicurezza elevata nell’utilizzo dei servizi.",
  "plan.enterprise.fullName": "Piano Enterprise",
  "plan.enterprise.name": "Enterprise",
  "plan.professional.bestLabel": "Il più popolare",
  "plan.professional.desc":
    "Per le aziende che hanno bisogno di coordinarsi e comunicare con tutti i propri collaboratori in modo semplice e intuitivo.",
  "plan.professional.fullName": "Piano Professional",
  "plan.professional.name": "Professional",
  "postmasters.list.header.dsc":
    "I Postmaster sono email account responsabili della gestione del proprio dominio e sono creati in automatico all'attivazione di un nuovo dominio.",
  "postmasters.list.header.title": "Postmaster",
  "prices.additionalServices.title": "Servizi aggiuntivi",
  "prices.annualTier.tableTitle": "Prezzi per abbonamenti annuali",
  "prices.archive.annual.label": "Archivio per abbonamento annuale",
  "prices.archive.desc":
    "Archiviazione in cloud, ricerca ed esportazione di tutti i messaggi ricevuti e inviati, conservandoli fino a un massimo di 10 anni. Attivalo nella sezione <a href='/archive'>Archivio</a> del Pannello. <b>I prezzi si intendono per Archivio attivato su singola casella.</b>",
  "prices.archive.label": "Archivio",
  "prices.archive.monthly.label": "Archivio per abbonamento mensile",
  "prices.archive.title": "Archivio email di sicurezza",
  "prices.backup.label": "Ripristino",
  "prices.backup.title": "Ripristino backup",
  "prices.contactUs": "Contattaci",
  "prices.ctaNotReady":
    "Ti trovi già nella fascia di sconto a te dedicata, in base al numero di caselle fatturabili. Al superamento della soglia indicata potrai richiedere l'accesso alla successiva fascia di sconto.",
  "prices.custom.sectionSubtitle": "Di seguito il dettaglio dei prezzi per casella in base al piano applicato.",
  "prices.custom.sectionTitle": "Prezzi per piano",
  "prices.custom.tier.disclaimer": "I prezzi si intendono per singola casella.",
  "prices.customQuotaContactUs":
    "Hai raggiunto le 200 caselle attive, contattaci per concordare insieme un piano adeguato alle tue necessità.",
  "prices.customTierMsg":
    "Hai <b>{count}</b> caselle fatturabili, fai parte dei nostri Rivenditori con un piano di sconto personalizzato. Di seguito il dettaglio dei prezzi applicati alle caselle in tua gestione.",
  "prices.dailyMessages.annuallyPrices": "Prezzi per abbonamenti annuali",
  "prices.dailyMessages.desc":
    "Per ogni email account è possibile impostare il limite dei messaggi che possono essere inviati ogni 24 ore. Sono disponibili tagli da 250, 1.000, 2.000 e 5.000 messaggi.",
  "prices.dailyMessages.monthlyPrices": "Prezzi per abbonamenti mensili",
  "prices.dailyMessages.title": "Limiti di invio giornaliero",
  "prices.disclaimer":
    "I prezzi si intendono per singola casella IVA esclusa. L'accesso e la permanenza nelle fasce di sconto è vincolato al rispetto dalle condizioni per i rivenditori di Qboxmail.",
  "prices.disclaimerAnnual": "I prezzi si intendono per singola casella IVA esclusa.",
  "prices.enduser.additionalServices.desc": "Puoi usufruire di altri servizi in associazione alla tua casella.",
  "prices.enduser.annualTier.disclaimer": "I prezzi si intendono per singola casella IVA esclusa.",
  "prices.enduser.monthlyTier.disclaimer":
    "I prezzi si intendono per singola casella IVA esclusa.<br/>Il minimo fatturabile in questa tipologia di abbonamento è 5 caselle.",
  "prices.enduser.sectionSubtitle":
    "Il prezzo delle singole caselle email è indicato in base alla dimensione, al piano e al tipo di abbonamento.",
  "prices.howMany": "Hai <b>{count} caselle </b> fatturabili.",
  "prices.howManyAnnual":
    "Hai <b>{count}</b> caselle fatturabili. <br/>Verifica il numero di caselle ordinate dalla sezione ordini o dalla tua fattura nell'area clienti. <br/>Se desideri ordinare nuove caselle o diminuire il numero di caselle ordinate, contattaci aprendo un Ticket.",
  "prices.howManyLessThan5": "Hai <b>{count} caselle </b> fatturabili. Il minimo fatturabile in questa fascia è 5.",
  "prices.howManyNotReseller":
    "Hai <b>{count} caselle </b> fatturabili. Il minimo fatturabile in questa fascia è {min}.",
  "prices.howManySubtitle": "Attivane altre per accedere alle successive fasce di sconto",
  "prices.howManySubtitleLastTier": "Attivane altre richiedere una fascia di sconto personalizzata.",
  "prices.is_rn":
    "ATTENZIONE, il prezzo che stai pagando per casella email è riferito ad un vecchio listino agevolato accordatoti in passato. Oggi questo prezzo non ci consente più di sostenere gli investimenti necessari all'erogazione del servizio. Al fine di continuare a garantirti un livello di servizio adeguato, nei prossimi mesi ti verrà applicata la fascia di sconto corrispondente al numero di caselle email attive.",
  "prices.is_rold":
    "ATTENZIONE, il prezzo che stai pagando per casella email è riferito ad un vecchio listino agevalato accordatoti in passato. Oggi questo prezzo non ci consente più di sostenere gli investimenti necessari all'erogazione del servizio. Al fine di continuare a garantirti un livello di servizio adeguato, in futuro potrà esserti applicata una diversa fascia di sconto. ",
  "prices.lessThan10":
    "Potrai richiedere l'accesso alle fasce di sconto per rivenditori una volta superate le 10 caselle email.",
  "prices.lower_than_min":
    "ATTENZIONE, il numero di caselle email fatturabili è inferiore al numero minimo previsto per rimanere nella fascia di sconto attuale. Se non attivi nuove caselle dal prossimo mese ti sarà applicata la corrispondente fascia di sconto.",
  "prices.missing": "{missing} caselle al prossimo sconto",
  "prices.monthlyTier.tableTitle": "Prezzi per abbonamenti mensili",
  "prices.navbarTooltipDesc": "Visualizza il tuo piano",
  "prices.navbarTooltipTitle": "Prezzi",
  "prices.ongoingUpgrade":
    "Abbiamo ricevuto la tua richiesta di passaggio alla nuova fascia di sconto, riceverai a breve un riscontro.",
  "prices.paid.backup.desc":
    "Ripristino di un backup di un account email ad uno dei 15 giorni precedenti alla data di oggi. Per richiederlo basta collegarsi alla Mail Time Machine dell’account. I prezzi si intendono per singolo ripristino a richiesta.",
  "prices.paid.enduser.archive.desc":
    "Archiviazione in cloud, ricerca ed esportazione di tutti i messaggi ricevuti e inviati, conservandoli fino a un massimo di 10 anni. Attivalo nella sezione Archivio del Pannello. I prezzi si intendono per Archivio attivato su singola casella.",
  "prices.privateLabel.desc":
    "Il Private Label permette di personalizzare i parametri di accesso ai servizi POP, IMAP, SMTP, DAV, Webmail, Pannello di Controllo, Mail Time Machine e Archivio con un proprio dominio, in modo che il certificato SSL risulti valido. La personalizzazione include anche i record MX ed SPF.",
  "prices.privateLabel.label": "Private Label",
  "prices.privateLabel.title": "Personalizzazione Private Label",
  "prices.promoMsg":
    "Ti trovi in questa fascia di sconto grazie ad un'offerta promozionale a te dedicata. Potrebbero esserci dei vincoli per continuare a rimanere in questa fascia.",
  "prices.request": "Richiedi",
  "prices.requested": "Richiesto",
  "prices.reseller.additionalServices.desc":
    "I servizi aggiuntivi ti permettono di personalizzare ed aumentare il valore della tua offerta di servizi email.",
  "prices.reseller.sectionSubtitle":
    "In base al numero di caselle attive e fatturate sono previste delle fasce di sconto dedicate. I prezzi sono riferiti al costo di una singola casella email.",
  "prices.reseller.tier.disclaimer": "I prezzi si intendono per singola casella, IVA esclusa.",
  "prices.sectionSubtitleAnnual":
    "In questa pagina trovi indicata la tua attuale fascia di sconto con i prezzi delle singole caselle divisi per piano.",
  "prices.sectionTitle": "Prezzi delle caselle email",
  "prices.servicesAccess.info": "Accedi alla tua area clienti per visualizzare i servizi attivi e le tue fatture.",
  "prices.tableLabel.mailboxes": "caselle",
  "prices.tierMinMsg": "Minimo caselle fatturabili in questo piano: {min}",
  "prices.trial.backup.desc":
    "Ripristino di tutti i messaggi di un account email ad uno dei 15 giorni precedenti alla data di oggi. Per richiederlo basta collegarsi alla Mail Time Machine dell’account.",
  "prices.trial.reseller.archive.desc":
    "Archiviazione in cloud, ricerca ed esportazione di tutti i messaggi ricevuti e inviati, conservandoli fino a un massimo di 10 anni. Attivalo nella sezione Archivio del Pannello.",
  "prices.trial.reseller.tierInfo":
    "Compila il form per scaricare il <b>Programma Rivenditori</b> e scoprire i prezzi e le fasce di sconto riservate ai rivenditori.",
  "prices.upgrade":
    "Hai raggiunto il numero di caselle attive necessario per richiedere l'accesso alla successiva fascia di sconto.",
  "prices.upgradeNotStandard":
    "Hai raggiunto le 200 caselle attive, contattaci per concordare insieme un piano adeguato alle tue necessità.",
  "prices.webLabel.desc":
    "Il Web Label permette di personalizzare gli URL di accesso ai servizi con certificato SSL. Potrai utilizzare un dominio a scelta ad esempio il nome della tua azienda o quella dei tuoi clienti. È possibile scegliere di personalizzare i seguenti moduli:<br/><span class='ml-5'>• 1° modulo: Webmail</span><br/><span class='ml-5'>• Altri moduli: Pannello di Controllo, Mail Time Machine, Archivio.</span>",
  "prices.webLabel.firstModule": "1° modulo",
  "prices.webLabel.secondModule": "Dal 2° modulo",
  "prices.webLabel.title": "Personalizzazione Web Label",
  "prices.webLabelModule": "modulo",
  "qbmove.error.auth_failed": "L'autenticazione dell'utente <b>{user}</b> con il server <b>{host}</b> è fallita",
  "qbmove.error.connection_failed": "Connessione per l'utente {user} a {host} fallita",
  "qbmove.error.folder_create_failed": "Impossibile creare la cartella {folder}",
  "qbmove.error.folder_select_failed": "Impossibile selezionare la cartella {folder}",
  "qbmove.error.imapsync_not_installed": "Imapsync non installato",
  "qbmove.error.max_size_exceeded":
    "Il messaggio con UID {uid} nella cartella {folder} supera la dimensione massima consentita",
  "qbmove.error.message_fetch_failed": "Impossibile recuperare il messaggio con UID {uid} nella cartella {folder}",
  "qbmove.error.overquota": "La casella di destinazione ha esaurito lo spazio disponibile",
  "qbmove.error.quota_exceeded":
    "Impossibile migrare il messaggio con UID {uid} nella cartella {folder}: quota esaurita",
  "qbmove.error.ssh_connect_denied": "Connessione SSH fallita",
  "qbmove.error.temporary_unavailable": "Connessione per l'utente {user} a {host} temporaneamente non disponibile",
  "qbmove.error.unhandled_error": "Errore sconosciuto, conttatta il supporto per maggiori informazioni",
  "qbmove.file_errors": "Errori nel file",
  "qbmove.first_execution": "Prima esecuzione",
  "qbmove.second_execution": "Seconda esecuzione",
  "qbmove.status.completed": "Completata",
  "qbmove.status.failed": "Fallita",
  "qbmove.status.running": "In corso: {percentage}%",
  "qbmove.status.runningTest": "In corso",
  "qbmove.status.soon": "Appena possibile",
  "qbmove.test_run": "Test autenticazione",
  "radiobtn.desc.customer.company": "Libero professionista o azienda in possesso di Partita IVA.",
  "radiobtn.desc.customer.private": "Utente in possesso di Codice Fiscale, ma non di Partita IVA.",
  "radiobtn.desc.customer.reseller":
    "Libero professionista o azienda, in possesso di Partita IVA, che acquista il servizio per rivenderlo a terzi.",
  "radiobtn.desc.payment.bankTransfer":
    "Scegliendo questo metodo di pagamento, i tuoi domini saranno disponibili dopo che riceveremo l'accredito dell'importo. Nella email di riepilogo troverai le istruzioni per eseguire il pagamento.",
  "radiobtn.desc.payment.creditCard":
    "Automatizza il pagamento delle fatture tramite la tua carta di credito/debito. Sono accettati tutti i principali circuiti, ad esempio Visa, Mastercard, American Express. L'addebito verrà eseguito alla data di scadenza della fattura.",
  "radiobtn.desc.payment.paypal":
    "Effettua il pagamento utilizzando il tuo account PayPal. Dovrai pagare manualmente le fatture seguendo le istruzioni presenti nel proforma entro la data di scadenza.",
  "radiobtn.desc.payment.paypal.auto":
    "Automatizza il pagamento delle fatture tramite il tuo conto PayPal. L'addebito verrà eseguito alla data di scadenza della fattura.",
  "radiobtn.label.accept": "Accetto",
  "radiobtn.label.customer.company": "Azienda",
  "radiobtn.label.customer.private": "Privato [solo residenti in Italia]",
  "radiobtn.label.customer.reseller": "Rivenditore",
  "radiobtn.label.noAccept": "Non accetto",
  "radiobtn.label.payment.bankTransfer": "Bonifico bancario",
  "radiobtn.label.payment.lcwsoftpaypalbillingagreements": "PayPal con addebito automatico",
  "radiobtn.label.payment.paypal": "PayPal con addebito manuale",
  "radiobtn.label.payment.stripe": "Carta di credito con addebito automatico",
  "report.desc.archive":
    "Contiene i dettagli di tutti gli archivi email presenti, in questo momento, all'interno del tuo account.",
  "report.desc.domain":
    "Contiene i dettagli di tutti i domini presenti, in questo momento, all'interno del tuo account.",
  "report.desc.domain.alias":
    "Contiene i dettagli di tutti i domini alias presenti, in questo momento, all'interno del tuo account.",
  "report.desc.domain.limits":
    "Contiene i dettagli di tutti i limiti sui domini presenti, in questo momento, all'interno del tuo account.",
  "report.desc.emailAccount":
    "Contiene i dettagli di tutti gli email account presenti, in questo momento, all'interno del tuo account.",
  "report.desc.emailAccount.alias":
    "Contiene i dettagli di tutti gli email alias presenti, in questo momento, all'interno del tuo account.",
  "report.list.header.dsc":
    "I Report ti permettono di scaricare dei resoconti dettagliati, in formato CSV, relativi alle risorse, ed ai loro limiti e consumi, presenti all'interno del tuo account.",
  "report.list.header.title": "Report",
  "report.title.archive": "Report Archivio Email",
  "report.title.domain": "Report Domini",
  "report.title.domain.alias": "Report Domini Alias",
  "report.title.domain.limits": "Report Limiti Domini",
  "report.title.emailAccount": "Report Email Account",
  "report.title.emailAccount.alias": "Report Email Alias",
  "reset.password.desc":
    "Scegli la password per accedere al tuo Pannello di controllo.<br/>Ti consigliamo di utilizzare una password sicura di almeno 8 caratteri alfanumerici.",
  "reset.password.title": "Imposta password",
  "section.view.account.email": "Email account",
  "section.view.account.email.settings": "Impostazioni email account",
  "section.view.admin": "Admin",
  "section.view.alias.email": "Email alias",
  "section.view.archive.account.email": "Archivio email account",
  "section.view.archive.domain": "Archivio dominio",
  "section.view.customer": "Cliente",
  "section.view.delegate": "Delegato",
  "section.view.domain": "Dominio",
  "section.view.domain.settings": "Impostazioni dominio",
  "section.view.import.resources": "Risorse importazione",
  "section.view.manager": "Manager",
  "section.view.migration.resources": "Risorse migrazione",
  "section.view.postmaster.settings": "Impostazioni postmaster",
  "section.view.teamMember": "Team member",
  "section.view.user.settings": "Impostazioni utente",
  "select.status.accept": "Accettati",
  "select.status.accepted": "Accettati",
  "select.status.account": "Utenza",
  "select.status.all": "Tutti",
  "select.status.authfailed": "Errori",
  "select.status.blocked": "Bloccati",
  "select.status.completed": "Completate",
  "select.status.completed_with_errors": "Completate con errori",
  "select.status.crashed": "Crashata",
  "select.status.delivery.domainsAggregation": "Aggrega per dominio",
  "select.status.delivery.singleDomain": "Singolo dominio",
  "select.status.disabled": "Disattivi",
  "select.status.enabled": "Attivi",
  "select.status.error": "Errori",
  "select.status.expired": "Scaduti",
  "select.status.failed": "Falliti",
  "select.status.failure": "Errori",
  "select.status.free": "Free",
  "select.status.invalid": "Non validi",
  "select.status.login-error": "Errori",
  "select.status.migrating": "In corso",
  "select.status.migrationResources.all": "Tutte",
  "select.status.migrationResources.failed": "Fallite",
  "select.status.migrationResources.running": "In corso",
  "select.status.migrationResources.success": "Completate",
  "select.status.ownership_check": "In attesa",
  "select.status.paid": "Paid",
  "select.status.qbmove.all": "Tutte",
  "select.status.qbmove.crashed": "Crashata",
  "select.status.qbmove.error": "Errori",
  "select.status.qbmove.running": "In corso",
  "select.status.qbmove.scheduled": "Programmata",
  "select.status.qbmove.success": "Completate",
  "select.status.qbmove.types.all": "Tutti i tipi",
  "select.status.qbmove.types.migration": "Migrazioni",
  "select.status.qbmove.types.vault_import": "Importazioni Archivio",
  "select.status.reject": "Respinti",
  "select.status.rejected": "Respinti",
  "select.status.running": "In esecuzione",
  "select.status.scheduled": "Programmati",
  "select.status.spam-mark": "Marcati spam",
  "select.status.success": "Accessi",
  "select.status.suppressionList.all": "Tutti",
  "select.status.suppressionList.disabled": "Consegna abilitata",
  "select.status.suppressionList.enabled": "Consegna bloccata",
  "select.status.trial": "Trial",
  "select.status.unhealthy": "Agg. Records MX",
  "select.status.updating": "Aggiornamento",
  "select.status.valid": "Validi",
  "select.status.validating": "In validazione",
  "select.status.waiting": "In attesa",
  "select.status.with errors": "Errori",
  "select.value.accesses": "Accessi",
  "select.value.aliasDomains": "Domini alias",
  "select.value.aliasEmails": "Email alias",
  "select.value.all": "Tutti",
  "select.value.allAccounts": "Tutti gli account",
  "select.value.annually": "Annuale",
  "select.value.crashed": "Crashati",
  "select.value.de": "Tedesco",
  "select.value.domains": "Domini",
  "select.value.dutch": "Olandese (si applica solo alla webmail)",
  "select.value.emailAccounts": "Account email",
  "select.value.english": "Inglese",
  "select.value.error": "Errori",
  "select.value.es": "Spagnolo",
  "select.value.fr": "Francese",
  "select.value.gr": "Greco",
  "select.value.hour": "ora",
  "select.value.hours": "ore",
  "select.value.imap": "IMAP",
  "select.value.italian": "Italiano",
  "select.value.mail.in": "Mail ricevute",
  "select.value.mail.out": "Mail inviate",
  "select.value.monthly": "Mensile",
  "select.value.never": "Mai",
  "select.value.nl": "Olandese",
  "select.value.pop": "POP",
  "select.value.pt": "Portoghese",
  "select.value.scheduled": "Programmate",
  "select.value.spanish": "Spagnolo",
  "select.value.sv": "Svedese",
  "select.value.webmail": "Webmail",
  "selectionCard.accounts": "Utenza",
  "selectionCard.domainsRanking": "Classifica dei domini",
  "selectionCard.domainsRanking.short": "Class. domini",
  "selectionCard.singleDomain": "Singolo dominio",
  "selectionCard.singleDomain.short": "Dominio",
  sendMessages: "messaggi",
  "settings.alert.dkim.disableFailed": "Disattivazione DKIM fallita",
  "settings.alert.dkim.resetFailed": "Reset DKIM fallito",
  "settings.alert.dkim.verifyFailed": "Verifica DKIM fallita. Assicurati di aver configuration i DNS correttamente",
  "settings.domain.title": "Impostazioni dominio",
  "settings.msg.dkim.activating": "Firma DKIM in attivazione",
  "settings.msg.dkim.disabling": "Firma DKIM in disattivazione",
  "settings.section.postmaster.desc":
    "L'utente postmaster rappresenta un email account come tutti gli altri, ma che ha la possibilità di gestire tutti gli altri account del dominio e di crearne di nuovi.",
  "settings.section.postmaster.title": "Postmaster",
  "settings.sections.account.limits.desc.customer":
    "Imposta il numero di domini, account e archivi attivabili dal cliente",
  "settings.sections.account.limits.desc.emailAccount": "Imposta la dimensione dell'email account.",
  "settings.sections.account.limits.title": "Limiti account",
  "settings.sections.accounts.desc": "Imposta le autorizzazioni di gestione degli account per il team member.",
  "settings.sections.accounts.title": "Gestione account",
  "settings.sections.accountsLimits.title": "Limiti degli account",
  "settings.sections.alias.title": "Alias",
  "settings.sections.analysis.desc": "Imposta l'accesso agli strumenti di analisi per il team member.",
  "settings.sections.analysis.title": "Supporto ed Analisi",
  "settings.sections.antimalwarePremium.desc":
    "Abilita un ulteriore livello di protezione per proteggere le caselle email del dominio.",
  "settings.sections.antimalwarePremium.title": "Antimalware Premium",
  "settings.sections.antispam.desc": "Descrizione livello antispam",
  "settings.sections.antispam.desc.domain":
    "Imposta il livello di sensibilità del filtro antispam per gli account del dominio. Ti consigliamo di mantenere quello predefinito.",
  "settings.sections.antispam.title": "Livello antispam",
  "settings.sections.api.desc.customer": "Consenti al cliente di accedere al pannello tramite API.",
  "settings.sections.api.desc.domain": "Consenti l'accesso agli account del dominio tramite API.",
  "settings.sections.api.desc.emailAccount": "Consenti l'accesso all'email account tramite API.",
  "settings.sections.api.desc.panel": "Consenti l'accesso al pannello tramite API.",
  "settings.sections.api.desc.teamMember": "Consenti l'accesso al team member tramite API.",
  "settings.sections.api.title": "Accesso API",
  "settings.sections.archive.desc": "Imposta le autorizzazioni di gestione dell'archivio per il team member.",
  "settings.sections.archive.import.desc":
    "L'Importazione consente di archiviare automaticamente tutti i messaggi presenti nel tuo email account, suddivisi fra ricevuti e inviati e organizzati per anno.",
  "settings.sections.archive.import.title": "Importazione",
  "settings.sections.archive.info.title": "Informazioni archivio",
  "settings.sections.archive.newAccounts.desc":
    "Definisci le impostazioni di archiviazione predefinite per i nuovi account del dominio.",
  "settings.sections.archive.newAccounts.title": "Nuovi account",
  "settings.sections.archive.retention.desc":
    "Scegli il periodo di conservazione predefinito per i messaggi degli account del dominio.",
  "settings.sections.archive.retention.desc.emailAccount":
    "Scegli il periodo di conservazione predefinito per i messaggi dell'email account.",
  "settings.sections.archive.retention.title": "Archiviazione",
  "settings.sections.archive.title": "Gestione archivio",
  "settings.sections.autoresponder.desc":
    "Imposta un messaggio di risposta automatica da inviare durante il periodo temporale da te scelto.",
  "settings.sections.autoresponder.title": "Risposta automatica",
  "settings.sections.canEditOutbound.desc": "Disabilità la possibilità di modificare i limiti di invio per un utente.",
  "settings.sections.canEditOutbound.title": "Limiti di invio",
  "settings.sections.catchAll.desc":
    "Imposta un indirizzo email a cui inviare i messaggi in caso di destinatario inesistente.",
  "settings.sections.catchAll.desc.customer": "Imposta la possibilità di attivare la catch all per il cliente.",
  "settings.sections.catchAll.title": "Catch all",
  "settings.sections.customerData.desc": "Inserisci le informazioni di contatto del cliente.",
  "settings.sections.customerData.title": "Informazioni cliente",
  "settings.sections.customerLimits.title": "Limiti",
  "settings.sections.customerOrder.title": "Ordine cliente",
  "settings.sections.customerType.desc": "Imposta la tipologia e la data di scadenza del cliente.",
  "settings.sections.customerType.title": "Tipologia cliente",
  "settings.sections.delegate.info.title": "Informazioni delegato",
  "settings.sections.delivery.desc": "Gestisci l'accesso al servizio di Email Delivery",
  "settings.sections.delivery.title": "Email Delivery",
  "settings.sections.deliverySettings.assignAccounts.desc":
    "Assegna manualmente al manager specifiche utenze e domini del servizio Email Delivery. Dopo l'assegnazione, il manager avrà pieno controllo su di essi attraverso il pannello di gestione.",
  "settings.sections.deliverySettings.assignAccounts.title": "Utenze e domini assegnati",
  "settings.sections.deliverySettings.newResourcesLimit.desc":
    "Definisci il limite massimo di utenze e domini che il manager può avere assegnato in qualsiasi momento.",
  "settings.sections.deliverySettings.newResourcesLimit.title": "Limiti Utenze e Domini Email Delivery",
  "settings.sections.dkim.desc": "Imposta una firma DKIM personalizzata per il dominio.",
  "settings.sections.dkim.title": "Firma DKIM personalizzata",
  "settings.sections.domain.limits.desc":
    "Imposta il numero di account e archivi attivabili per il dominio e la dimensione degli account in esso contenuti.",
  "settings.sections.domain.limits.title": "Limiti dominio",
  "settings.sections.domains.desc": "Imposta le autorizzazioni di gestione dei domini per il team member.",
  "settings.sections.domains.maxAccountSize":
    "Il costo degli account viene sempre calcolato in base alla dimensione predefinitia più prossima (8GB, 25GB. 50GB o 100GB) rispetto alla dimensione selezionata.",
  "settings.sections.domains.maxAccountsAvailable":
    "Imposta il numero di account e archivi che possono essere attivati ​​per il dominio.",
  "settings.sections.domains.maxAccountsAvailable.title": "Account attivabili",
  "settings.sections.domains.title": "Gestione domini",
  "settings.sections.emailAccout.availableSpace": "Spazio disponibile",
  "settings.sections.emailAccout.desc": "Inserisci le informazioni di contatto dell'email account.",
  "settings.sections.emailAccout.title": "Informazioni account",
  "settings.sections.emailNotifications.desc":
    "Imposta un indirizzo email dove ricevere notifiche di allerta riguardo a domini e account.",
  "settings.sections.emailNotifications.title": "Notifiche email",
  "settings.sections.forwards.desc":
    "Inserisci uno o più indirizzi alternativi ai quali inoltrare i messaggi ricevuti dall'email account.<br/><b>Puoi inserire fino a 20 indirizzi</b>.",
  "settings.sections.forwards.title": "Inoltri",
  "settings.sections.general.title": "Impostazioni generali",
  "settings.sections.ipEnabled.desc.domain":
    "Restringi l'accesso agli account del dominio solo agli indirizzi IP che ritieni sicuri.<br/><b>Puoi inserire fino a 5 indirizzi/classi IP a cui applicare le restrizioni per i servizi POP, IMAP, SMTP, Webmail e API.</b>",
  "settings.sections.ipEnabled.desc.emailAccount":
    "Restringi l'accesso all'account email solo agli indirizzi IP che ritieni sicuri.<br/><b>Puoi inserire fino a 5 indirizzi/classi IP a cui applicare le restrizioni per i servizi POP, IMAP, SMTP, Webmail e API.</b>",
  "settings.sections.ipEnabled.desc.panel":
    "Restringi l'accesso al pannello e alle API solo agli indirizzi IP che ritieni sicuri.",
  "settings.sections.ipEnabled.title": "IP abilitati",
  "settings.sections.languageTimeZone.desc.customer": "Imposta la lingua e il fuso orario del pannello per il cliente.",
  "settings.sections.languageTimeZone.desc.domain":
    "Imposta la lingua predefinita e il fuso orario per il dominio e per gli account in esso contenuti.",
  "settings.sections.languageTimeZone.desc.emailAccount":
    "Imposta la lingua e il fuso orario predefiniti per l'email account.",
  "settings.sections.languageTimeZone.desc.panel": "Imposta la lingua e il fuso orario del pannello.",
  "settings.sections.languageTimeZone.title": "Lingua e time zone",
  "settings.sections.limits.access.desc":
    "Definisci i domini e gli account di cui il delegato può prendere visione. <b>Puoi autorizzare il delegato ad accedere a più domini e account</b>.",
  "settings.sections.limits.access.title": "Accesso contenuti",
  "settings.sections.limits.time.desc": "Imposta l'intervallo temporale di accesso del delegato all'archivio.",
  "settings.sections.limits.time.title": "Limiti temporali",
  "settings.sections.managerLimits.desc":
    "Imposta il numero di account e archivi attivabili dal manager e assegnagli i domini da gestire.",
  "settings.sections.managerLimits.title": "Limiti manager",
  "settings.sections.other.title": "Altro",
  "settings.sections.otp.desc.domain":
    "Imposta le policy relative alla autenticazione a due fattori (OTP) per gli account del dominio.",
  "settings.sections.otp.desc.emailAccount":
    "Imposta le policy relative alla autenticazione a due fattori (OTP) per l'email account.",
  "settings.sections.otp.desc.panel":
    "Imposta l’autenticazione a due fattori (OTP) per accedere in sicurezza al panello.",
  "settings.sections.otp.title": "Autenticazione OTP",
  "settings.sections.password.desc": "Cambia la password per accedere al pannello",
  "settings.sections.password.desc.admin": "Cambia la password dell'admin per accedere al pannello",
  "settings.sections.password.desc.customer": "Cambia la password del cliente per accedere al panello.",
  "settings.sections.password.desc.delegate": "Cambia la password del delegato per accedere all'archivio.",
  "settings.sections.password.desc.domain":
    "Imposta le policy relative alla gestione delle password per gli account del dominio.",
  "settings.sections.password.desc.emailAccount":
    "Cambia la password e imposta le policy relative alla gestione delle password per l'email account.",
  "settings.sections.password.desc.manager": "Cambia la password del manager per accedere al pannello.",
  "settings.sections.password.desc.panel": "Cambia la password del tuo account per accedere al pannello.",
  "settings.sections.password.desc.teamMember": "Cambia la password del team member per accedere al pannello.",
  "settings.sections.password.title": "Password",
  "settings.sections.passwordExpiration.desc":
    "Imposta le policy relative alla scadenza della password di tutti gli account del dominio",
  "settings.sections.passwordExpiration.emailDesc":
    "Imposta le policy relative alla scadenza della password dell'email account",
  "settings.sections.passwordExpiration.title": "Scadenza Password",
  "settings.sections.planManagement.desc":
    "Imposta un piano per il dominio. Il cambio di piano comporta una variazione del costo e delle funzionalità disponibili.",
  "settings.sections.planManagement.title": "Gestione piano",
  "settings.sections.registry.desc.domain":
    "Inserisci le informazioni di contatto predefinite per i nuovi email account.",
  "settings.sections.registry.title.domain": "Anagrafica dominio",
  "settings.sections.registryCompany.title": "Informazioni aziendali",
  "settings.sections.sentLimits.desc.domain":
    "Imposta il limite giornaliero di invio messaggi predefinito per gli account email del dominio.",
  "settings.sections.sentLimits.desc.emailAccount":
    "Imposta il limite giornaliero di invio messaggi per l'account email.",
  "settings.sections.sentLimits.title": "Limite di invio giornaliero",
  "settings.sections.services.desc": "Descrizione servizi",
  "settings.sections.services.desc.domain":
    "Imposta i servizi disponibili per gli account del dominio. <b>I servizi variano in base al piano selezionato per il dominio</b>.",
  "settings.sections.services.desc.emailAccount":
    "Imposta i servizi disponibili per l'email account. <b>I servizi variano in base al piano e alle impostazioni del dominio</b>.",
  "settings.sections.services.title": "Servizi",
  "settings.sections.settingsWebmail.desc":
    "I nuovi utenti avranno questi come valori predefiniti, potrai cambiargli dalle Impostazioni del singolo account o le potrà modificare l'utente stesso dalle impostazioni della Webmail.",
  "settings.sections.settingsWebmail.email.desc":
    "Definisci le impostazioni di localizzazione della Webmail che vedrà questo utente. L'utente potrà poi modificarle in autonomia dalle impostazioni della Webmail.",
  "settings.sections.settingsWebmail.email.title": "Localizzazione",
  "settings.sections.settingsWebmail.signature.desc":
    "Gestisci in maniera centralizzata le firme delle email inviate da tutti gli utenti del dominio. Inserisci un modello per la firma e scegli a quali utenti applicarla.",
  "settings.sections.settingsWebmail.signature.field-c": "Paese",
  "settings.sections.settingsWebmail.signature.field-c_uid": "Indirizzo email",
  "settings.sections.settingsWebmail.signature.field-facsimiletelephonenumber": "Fax",
  "settings.sections.settingsWebmail.signature.field-givenname": "Nome",
  "settings.sections.settingsWebmail.signature.field-l": "Città",
  "settings.sections.settingsWebmail.signature.field-mobile": "Cellulare",
  "settings.sections.settingsWebmail.signature.field-mozillasecondmail": "Email secondaria",
  "settings.sections.settingsWebmail.signature.field-o": "Nome Azienda",
  "settings.sections.settingsWebmail.signature.field-ou": "Reparto",
  "settings.sections.settingsWebmail.signature.field-postalcode": "Zip",
  "settings.sections.settingsWebmail.signature.field-sn": "Cognone",
  "settings.sections.settingsWebmail.signature.field-st": "Regione",
  "settings.sections.settingsWebmail.signature.field-street": "Via",
  "settings.sections.settingsWebmail.signature.field-telephonenumber": "Telefono azienda",
  "settings.sections.settingsWebmail.signature.field-title": "Ruolo",
  "settings.sections.settingsWebmail.signature.subdesc":
    "Utilizza le variabili per comporre in maniera dinamica il modello della firma di tutti gli utenti. Le variabile verranno sostituite con il corrispondete valore presente nell'Anagrafica aziendale.<br/>Il simbolo {icon} indica che alcuni utenti non hanno il campo corrispondente impostato nella loro anagrafica.",
  "settings.sections.settingsWebmail.signature.subtitle": "Variabili disponibili",
  "settings.sections.settingsWebmail.signature.title": "Firma email centralizzata",
  "settings.sections.settingsWebmail.title": "Impostazioni predefinite per i nuovi account",
  "settings.sections.settingsWebmailHideAddressbook.desc":
    "Permette di stabilire se, come impostazione predefinita, quando si crea un nuovo account email, questo non deve essere mostrato nella Rubrica Aziendale.<br/><br/> Potrai modificare questa configurazione successivamente dalle impostazioni della singola casella email.",
  "settings.sections.settingsWebmailHideAddressbook.title": "Rubrica Aziendale",
  "settings.sections.settingsWebmailHideAddressbookEmail.desc":
    "Permette di stabilire se questo utente non deve essere mostrato nella Rubrica Aziendale.",
  "settings.sections.tracemail21DaysLimit.desc":
    "Tracemail consente di visualizzare i log fino a 30 giorni, puoi limitare la visiblità a 21 giorni.",
  "settings.sections.tracemail21DaysLimit.title": "Visiblità log Tracemail",
  "settings.sections.tracemail21DaysLimitDefault.desc":
    "Tracemail consente di visualizzare i log fino a 30 giorni, puoi limitare la visiblità a 21 giorni per tutti i nuovi domini.",
  "settings.sections.tracemail21DaysLimitDefault.title": "Visibilità Log Tracemail per nuovi domini",
  "settings.sections.webhook.desc": "Imposta un URL dove ricevere una chiamata HTTP di notifica.",
  "settings.sections.webhook.title": "Webhook",
  "settings.sections.webmailSignature.body":
    "Permette di gestire le identità collegate all'indirizzo email principale ed email alias associati all'utente. E' possibile personalizzare per ogni indirizzo email il nome visualizzato e la firma. <br/>Queste informazioni permettono di inviare messaggi con nomi ed indirizzi email diverso dal proprio.",
  "settings.sections.webmailSignature.title": "Firma e identità",
  showPrices: "Mostra prezzi",
  "sidebar.category.analysis": "Analisi",
  "sidebar.category.importsMigrations": "Importazioni e Migrazioni",
  "sidebar.category.management": "Gestione",
  "sidebar.category.roles": "Ruoli",
  "sidebar.category.send": "Invio",
  "sidebar.item.account.email": "Account",
  "sidebar.item.admins": "Admin",
  "sidebar.item.alias.emails": "Email alias",
  "sidebar.item.archive": "Archivio",
  "sidebar.item.auditLogs": "Registro",
  "sidebar.item.customers": "Clienti",
  "sidebar.item.customizations": "Personalizzazioni",
  "sidebar.item.dashboard": "Dashboard",
  "sidebar.item.delegates": "Delegati",
  "sidebar.item.domainProfiles": "Profili dominio",
  "sidebar.item.domains": "Domini",
  "sidebar.item.emailDelivery": "Email Delivery",
  "sidebar.item.emailDelivery.accounts": "Utenze",
  "sidebar.item.emailDelivery.suppressionList": "Lista di soppressione",
  "sidebar.item.etlive": "Tracemail",
  "sidebar.item.home": "Home",
  "sidebar.item.imports": "Importazioni",
  "sidebar.item.managers": "Manager",
  "sidebar.item.migrationOptions": "Opzioni di migrazione",
  "sidebar.item.migrationStatus": "Qbmove",
  "sidebar.item.migrations": "Migrazioni",
  "sidebar.item.mtm_requests": "Richieste di ripristino",
  "sidebar.item.mx": "MX personalizzati",
  "sidebar.item.news": "News",
  "sidebar.item.orders": "Ordini",
  "sidebar.item.orderslist": "Fatture",
  "sidebar.item.postmasters": "Postmaster",
  "sidebar.item.prices": "Prezzi",
  "sidebar.item.reports": "Report",
  "sidebar.item.send.users": "Utenti",
  "sidebar.item.support": "Supporto",
  "sidebar.item.teamMembers": "Team",
  "signature.maxImageSize": "Questa immagine ({size}) supera la dimensione massima consentita:",
  "signature.maxSize": "Questa firma ({size}) supera la dimensione massima consentita:",
  "status.archiveActivating": "Archivio in abilitazione",
  "status.completedWithErrors": "Completata con errori",
  "status.deleting": "In eliminazione",
  "status.disabled": "Disabilitato",
  "status.disabledByAdmin": "Disabilitato da admin",
  "status.disabledByCustomer": "Disabilitato da cliente",
  "status.disabledByManager": "Disabilitato da manager",
  "status.disabledByVetting": "Disabilitato dal vetting",
  "status.disabling": "In disabilitazione",
  "status.enabled": "Attivo",
  "status.expired": "Scaduto",
  "status.failure": "Qualcosa è andato storto, contattaci",
  "status.failureLong": "Qualcosa è andato storto, contattaci per risolvere il problema",
  "status.invalidResources": "Risorse invalide",
  "status.migrationInvalid": "Non valida",
  "status.scheduledDeleting": "La cancellazione avverrà stanotte",
  "status.unhealthy": "Dominio attivo. Aggiorna o verifica i record MX",
  "status.updating": "In aggiornamento",
  "status.validWithSkipped": "Valida con risorse saltate",
  "status.validating": "In validazione",
  "status.validatingResources": "Validazione risorse in corso",
  "status.waitingConfirmation": "In attesa di conferma",
  "status.waitingOwnership": "In attesa di verifica delle proprietà",
  "status.waitingPayment": "In attesa di pagamento",
  "support.ticket.desc":
    "Invia un messaggio al nostro supporto tecnico descrivendo il più dettagliatamente possibile il problema. Ti risponderemo il prima possibile.",
  "support.ticket.sent":
    "<b>Ticket inviato con successo</b>.<br/>Riceverai una email con la risposta del nostro supporto tecnico.<br/>Nel caso volessi contattarci telefonicamente trovi tutti i nostri riferimenti nella pagina contatti del nostro sito web. ",
  "support.ticket.title": "Hai bisogno di aiuto?",
  "supportContactBox.cta": "Chiama il nostro servizio clienti",
  "supportContactBox.question": "Hai bisogno di aiuto?",
  "supportContactBox.schedule": "Dal lunedì al venerdì 09:00 - 18:00",
  "suppressionList.enabledDelivery": "Consegna abilitata",
  "suppressionList.imports.add.desc":
    "Crea il file .CSV con le informazioni necessarie e importa fino a 300 indirizzi email alla lista di soppressione.",
  "tab.aliasDomains": "Domini alias",
  "tab.approval": "Approvazione",
  "tab.autoresponder": "Autorisponditore",
  "tab.changePlan": "Cambia piano",
  "tab.connectedAccounts": "Utenze associate",
  "tab.customizations.domains": "Per dominio",
  "tab.customizations.general": "Generale",
  "tab.customizations.managers": "Generali dei tuoi manager",
  "tab.deleteAccount": "Elimina account",
  "tab.delivery": "Email Delivery",
  "tab.deliveryLimits": "Limiti Email Delivery",
  "tab.details": "Dettagli",
  "tab.detailsAndSecurity": "Dettagli e Sicurezza",
  "tab.domains": "Domini",
  "tab.emailAccounts": "Email account",
  "tab.emailAlias": "Email alias",
  "tab.emailArchive": "Archivio email",
  "tab.emailHosting": "Email Hosting",
  "tab.emailHostingLimits": "Limiti Email Hosting",
  "tab.general": "Generali",
  "tab.limits": "Limiti",
  "tab.notification": "Notifiche",
  "tab.orders": "Ordini",
  "tab.owner": "Proprietario",
  "tab.postmaster": "Postmaster",
  "tab.registry": "Anagrafica",
  "tab.security": "Sicurezza",
  "tab.serviceManagement": "Gestione servizio",
  "tab.settings": "Impostazioni",
  "tab.trust": "Trust",
  "tab.verify": "Verifica",
  "tab.verify.dns": "Verifica via DNS",
  "tab.verify.email": "Verifica via email",
  "tab.verify.html": "Verifica via HTML",
  "tab.volumeManagement": "Messaggi disponibili",
  "tab.volumeManagement.desc": "Imposta il numero di messaggi disponibili per il dominio.",
  "tab.webmail": "Webmail",
  "table.header.account": "Account",
  "table.header.accounts": "Account",
  "table.header.accounts.100gb": "100GB",
  "table.header.accounts.25gb": "25GB",
  "table.header.accounts.50gb": "50GB",
  "table.header.accounts.8gb": "8GB",
  "table.header.accounts.archive": "Arch.",
  "table.header.alias": "Alias",
  "table.header.alias.domain": "D. alias",
  "table.header.alias.email": "E. alias",
  "table.header.category": "Categoria",
  "table.header.code": "Codice",
  "table.header.company": "Azienda",
  "table.header.country": "Nazione",
  "table.header.customer": "Cliente",
  "table.header.customization": "Cust.",
  "table.header.date": "Data",
  "table.header.date.added": "Aggiunto",
  "table.header.date.creation": "Creato il ",
  "table.header.date.expiry": "Scadenza",
  "table.header.delegates": "Delegati",
  "table.header.delivered": "Consegnati",
  "table.header.delivery.account": "Utenza",
  "table.header.delivery.account.name": "Nome",
  "table.header.delivery.account.username": "Username",
  "table.header.delivery.description": "Descrizione",
  "table.header.delivery.suppressionList.account": "Utenza",
  "table.header.deliveryDomain.accounts": "Utenze associate",
  "table.header.description": "Descrizione",
  "table.header.destinations": "Destinazioni",
  "table.header.domain": "Dominio",
  "table.header.domains": "Domini",
  "table.header.ehawk": "Ehawk",
  "table.header.email": "Email",
  "table.header.error": "Errore",
  "table.header.error_category": "Tipo",
  "table.header.errors": "Errori",
  "table.header.lastAccess": "Ultimo accesso",
  "table.header.log1": "Log 1",
  "table.header.log2": "Log 2",
  "table.header.logo": "Logo",
  "table.header.managers": "Manager",
  "table.header.messagesIn24H": "Messaggi in 24h",
  "table.header.mx1": "MX 1",
  "table.header.mx2": "MX 2",
  "table.header.not.delivered": "Non recapitati",
  "table.header.owner": "Proprietario",
  "table.header.plan": "Piano",
  "table.header.processed": "Processati",
  "table.header.quote": "Quota",
  "table.header.reason": "Motivo",
  "table.header.remote.server": "Server remoto",
  "table.header.remote.username": "Username remoto",
  "table.header.resources": "Risorse",
  "table.header.retention": "Archiviazione",
  "table.header.scheduled.migration.first": "1° migrazione",
  "table.header.scheduled.migration.second": "2° migrazione",
  "table.header.status": "Status",
  "table.header.supportURL": "Link supporto",
  "table.header.suppressed": "Soppressi",
  "table.header.time": "Ora",
  "table.header.type": "Tipo",
  "table.header.verification": "Verifica",
  "table.header.who": "Autore",
  "table.row.add.desc.customization": "Personalizza i tuoi domini con logo e nome della tua azienda.",
  "table.row.add.desc.domain": "Aggiungi un dominio alla lista e inizia a gestire i tuoi account email.",
  "table.row.add.desc.domainAlias": "Aggiungi un dominio alias alla lista e inizia a gestire i tuoi alias.",
  "table.row.add.desc.emailAccout": "Aggiungi un email account alla lista e inizia a gestire i tuoi account.",
  "table.row.add.desc.emailAlias": "Aggiungi un email alias alla lista e inizia a gestire i tuoi alias.",
  "table.row.add.desc.import":
    "Aggiungi una importazione e inserisci nel pannello tutti i tuoi domini e email account.",
  "table.row.add.desc.manager": "Aggiungi un manager e assegnagli i domini da gestire.",
  "table.row.add.desc.migration": "Aggiungi una migrazione e trasferisci tutti i tuoi messaggi.",
  "table.row.add.desc.postmaster": "Il Postmaster verrà automaticamente creato all'aggiunta di ogni dominio.",
  "table.row.add.desc.suppressionList": "Aggiungi singoli indirizzi o importa una lista.",
  "table.row.add.desc.teamMembers": "Aggiungi un team member e delega la gestione dei tuoi domini.",
  "table.row.add.msg.customization": "Aggiungi personalizzazione",
  "table.row.add.msg.domain": "Aggiungi dominio",
  "table.row.add.msg.domainAlias": "Aggiungi dominio alias",
  "table.row.add.msg.emailAccout": "Aggiungi email account",
  "table.row.add.msg.emailAlias": "Aggiungi email alias",
  "table.row.add.msg.import": "Aggiungi importazione",
  "table.row.add.msg.manager": "Aggiungi manager",
  "table.row.add.msg.migration": "Aggiungi migrazione",
  "table.row.add.msg.postmaster": "Non ci sono Postmaster",
  "table.row.add.msg.suppressionList": "La lista di soppressione è vuota",
  "table.row.add.msg.teamMembers": "Aggiungi team member",
  "table.row.desc.selectCustomer": "Devi selezionare un cliente per poter accedere alla sua lista di soppressione.",
  "table.row.msg.selectCustomer": "Seleziona un cliente",
  "tag.signature.bcc": "Ccn",
  "tag.signature.default": "Pred.",
  "teamMembers.add.desc.step1": "Inserisci le informazioni di contatto e imposta una password per il team member.",
  "teamMembers.add.desc.step2": "Imposta le autorizzazioni di gestione dei domini per il team member.",
  "teamMembers.add.desc.step3": "Imposta le autorizzazioni di gestione degli account per il team member.",
  "teamMembers.add.desc.step4": "Imposta le autorizzazioni di gestione dell'archivio per il team member.",
  "teamMembers.add.desc.step5": "Imposta l'accesso agli strumenti di analisi per il team member.",
  "teamMembers.add.error.noPermission": "Deve avere almeno 1 permesso assegnato",
  "teamMembers.add.title.step1": "Nuovo team member",
  "teamMembers.add.title.step2": "Gestione domini",
  "teamMembers.add.title.step3": "Gestione account",
  "teamMembers.add.title.step4": "Gestione archivi",
  "teamMembers.add.title.step5": "Strumenti di analisi e sicurezza e supporto",
  "teamMembers.forbiddenAction": "Non hai permessi per completare questa azione",
  "teamMembers.forbiddenActionSubtitle": "Contatta l'amministratore per ottenere i permessi necessari",
  "teamMembers.list.header.dsc":
    "I Team member hanno accesso alle impostazioni di tutti i domini e degli account in essi presenti secondo le limitazioni impostate dall'amministratore.",
  "teamMembers.list.header.title": "Team member",
  "tooltip.country": "Paese",
  "tour.step1.description":
    "Il Pannello di Controllo è ricco di funzionalità.<br>Scopri da dove cominciare e come diventare un Power User.",
  "tour.step1.title": "Ecco 3 suggerimenti per diventare un Power User",
  "tour.step2.description": "Nella sezione Gestione potrai:<br>",
  "tour.step2.listItem1": "Gestire la <b>quota</b> delle caselle email",
  "tour.step2.listItem2": "Cambiare <b>piano</b> per i domini",
  "tour.step2.listItem3": "Impostare le Policy per la <b>Sicurezza</b>",
  "tour.step2.listItem4": "Creare <b>firme</b> email centralizzate",
  "tour.step2.listItem5": "Personalizzare il servizio con il <b>tuo logo</b>",
  "tour.step2.listItem6": "E molto altro...",
  "tour.step2.title": "Crea e gestisci domini e caselle email",
  "tour.step3.description": "Crea diversi Ruoli per la gestione delle caselle dei tuoi clienti:",
  "tour.step3.listItem1": "<b>Team</b> - Crea utenze per i tuoi collaboratori",
  "tour.step3.listItem2": "<b>Postmaster</b> - Permetti ai tuoi clienti di gestire i loro domini",
  "tour.step3.listItem3": "<b>Manager</b> - Rivendi il servizio ad altri rivenditori",
  "tour.step3.title": "Il Pannello di Controllo è Multi-Livello",
  "tour.step4.description":
    "Identifica rapidamente i problemi di gestione delle email, risparmiando tempo e frustrazione:",
  "tour.step4.listItem1": "<b>Tracemail</b> - Individua problemi legati ad accessi e deliverability",
  "tour.step4.listItem2": "<b>Registro</b> - Monitora ogni attività svolta dagli account in gestione",
  "tour.step4.listItem3": "<b>Report</b> - Genera report sugli account attivi sul Pannello di Controllo",
  "tour.step4.title": "Strumenti di analisi e Help Desk",
  "tour.step5.content": "Il tuo tour è qui!",
};
